/// <reference path="../public/jquery-1.6.2.min.js" />
/// <reference path="../public/AJAX.js" />
/// <reference path="../public/General.js" />
/// <reference path="../public/Security.js" />
/// <reference path="../public/ServiceURL.js" />
/// <reference path="../SumoDataAccess.js" />
/// <reference path="../SumoClass.js" />
/// <reference path="Default.js" />
/// <reference path="DataObjects.js" />



//** NOTES
//1. ReportsData has page specific constants.
//2. I am not sure how resetContentHolders are supposed to work.


//TODO: Move some Cache Items from Reports JS file to appropriate locations.  I do not think they are needed elsewhere but the user shouldn't have to
//build all of these items everytime the page loads.  We might just move Reports,ReportFilters, and ReportGroupReports since these are not user specific.

var mReportsControls,
    mReportsData;
// Add this initialization function

function initReports() {
    mReportsControls = new ReportsControls();
    mReportsData = new ReportsData();
}

function resetContentHoldersReports() {
    "use strict";
    var lWindowHeight = $(window).height();

    // check size
    if (lWindowHeight < 800) {
        $('#' + mReportsData.Container).addClass('ReportsLength');
    }
    else {
        $('#' + mReportsData.Container).removeClass('ReportsLength');
    }

}



//-----------------------
// State Manager Handlers
//-----------------------
function mStateManagerReports_Init(aPrevious, aCurrent) {
    "use strict";
    initReports();
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        mReportsControls.CardViewTimer = new TimerManager(500);
        $('#uMasterMenuPanel').show();
        var lLayout = aCurrent.Tab + '.Layout.htm';
        populateElement('uMasterContentHolder', lLayout, mStateManagerReports_OnComplete);
    }
}

function mStateManagerReportsLayout_PreInitLoaded(aSender, aCacheItem, aData) {
    "use strict";
    mCache.unbind(aData.CacheItem + 'updated', mStateManagerReportsLayout_PreInitLoaded);
    mStateManagerReportsLayout_PreInit(aSender, aCacheItem, aData);
}
function mStateManagerReportsLayout_PreInit(aSender, aCacheItem, aData) {
    "use strict";
    if (aData.CacheItem == 'ReportInstance') {
        mCache.unbind(aData.CacheItem + 'updated', mStateManagerReportsLayout_PreInit);
        mCache.bind(aData.CacheItem + 'updated', reportsDataItem_Updated);
    }
    if (!PopupIsOpen()) {
        if (--mReportsData.CacheItemsRemaining === 0) {
            mStateManagerReportsLayout_Init(null, aData.Current);
        }
    }
}

function mStateManagerReportsLayout_Init(aPrevious, aCurrent) {
    "use strict";
    var reportsUrl = veritracks.system.clientSetting('ReportUrlPrepend');

    if (applyUserPermissionsNavigation(gPageClassManager.Reports, aCurrent.Settings[0])) {
        $('.LayoutTab.Selected').removeClass('Selected');
        $('#u' + aCurrent.Tab + 'LayoutTab' + aCurrent.Settings[0]).addClass('Selected');
        mReportsData.AddReportsReady = false;
        if (reportsUrl) {
            mReportsData.ReportURLPrepend = reportsUrl;
        }
        $('#uAddReportButton').addClass('Disabled');
        if (aCurrent.Settings[0] == 'Reports') {
            reportsDataListConverter();
            reportsCardView_Init();
            mReportsControls.CardViewFilter.filter();
        } else {
            reportsScheduleCardView_Init();
            reportsScheduleDataListConverter();
            mReportsControls.SchedulesCardViewFilter.filter();
        }
        mActivityNotification.addNotification(localizeWrapper('cReportAddAvailable'));
        $('#uAddReportButton').removeClass('Disabled');
        loadReportsCacheInit(mStateManager.Hash());
        mReportsData.AddReportsReady = true;
        mStateManagerReportsLayout_OnComplete();
     }
}




//--------------
// Load Complete
//--------------
function mStateManagerReports_OnComplete() {
    "use strict";
    applyUserPermissions([36, 72]);
    reportsCache_Init(mStateManager.Hash());
    $(window).resize();
}

function mStateManagerReportsLayout_OnComplete() {
    "use strict";

    applyUserPermissions([72,73,74,36]);
    mStateManagerReportsPrimary_Init(null, mStateManager.Hash());
}

function mStateManagerReportsPrimary_Init(aPrevious, aCurrent) {
    "use strict";
    var lFilename = 'Reports.' + aCurrent.Settings[0] + '.' + aCurrent.Settings[1] + '.Layout.htm',
        lPageClass = gPageClassManager.ReportDetailsPrimary;

    if (aCurrent.Settings[0] == 'Reports') {
        $('#uReportsSecondaryContentHolder').hide();
    } else {
        lPageClass = gPageClassManager.ReportSchedulesPrimary;
        $('#uReportsSecondaryContentHolder').show();
    }
    if (applyUserPermissionsNavigation(lPageClass, aCurrent.Settings[1])) {
        populateElement('uReportsMainContentPanel', lFilename, mStateManagerReportsPrimary_OnComplete);
     }

}

function mStateManagerReportsPrimary_OnComplete() {
    "use strict";
    applyUserPermissions([72, 73, 74, 36]);
    if (mStateManager.Settings()[0] === 'Schedules') {
        mReportsControls.SchedulesCardViewFilter.filter();
        mStateManagerReportsSecondary_Init(null, mStateManager.Hash());
    } else {
        reportInstanceFilters_Init();
        mReportsControls.CardViewFilter.filter();
    }
}

function mStateManagerReportsSecondary_Init(aPrevious, aCurrent) {
    "use strict";
    if (aCurrent.Settings[2] && applyUserPermissionsNavigation(gPageClassManager.ReportSchedulesSecondary, aCurrent.Settings[2], false)) {
        var lFilename = 'Reports.' + aCurrent.Settings[0] + '.' + aCurrent.Settings[1] + '.' + aCurrent.Settings[2] + '.Layout.htm';
        $('.ContentSecondaryTab.Selected').removeClass('Selected');
        $('.ContentSecondaryTab.' + aCurrent.Settings[2] + 'Tab').addClass('Selected');
        populateElement('uReportsSecondaryContentPanel', lFilename, mStateManagerReportsSecondary_OnComplete);
    }
}

function mStateManagerReportsSecondary_OnComplete() {
    "use strict";

    if (mStateManager.Settings()[2]) {
        applyUserPermissions([72, 73, 74, 36]);
        $(window).resize();

        window['mStateManagerReportsSecondary' + mStateManager.Settings()[2] + '_Init']();
    }
    // localize here
    veritracks.localization.localizeTitle();
}

function mStateManagerReportsSecondaryDetails_Init() {
    "use strict";
}

function mStateManagerReportsSecondaryFilters_Init() {
    "use strict";
    var lSelectedReportSchedule = mReportsControls.SchedulesCardView.selectedDataItem();
    uReportsScheduleFilterListView_Init();

    $('#uDeleteScheduleFilterButton').hide();
    $('#uEditScheduleFilterButton').hide();
    PopulateReportScheduleFilters(lSelectedReportSchedule.Id);
}

function mStateManagerReportsSecondaryEmails_Init() {
    "use strict";

    uReportsScheduleEmailListView_Init();
    var lSelectedReportSchedule = mReportsControls.SchedulesCardView.selectedDataItem();
    $('#uEditScheduleEmailButton').hide();
    $('#uDeleteScheduleEmailButton').hide();
    PopulateReportScheduleEmails(lSelectedReportSchedule.Id);
    uScheduleEmailAddButtonHide();
}

//------
// Leave
//------
function mStateManagerReports_Leave(aPrevious, aCurrent) {
    "use strict";
    mCache.RemoveItem('Reports');
    mCache.unbind('Reportsupdated', mStateManagerReportsLayout_PreInit);
    if (getViewState("LongRunningReport") == null || getViewState("LongRunningReport").Value == null) {
        mCache.RemoveItem('ReportInstance');
        mCache.unbind('ReportInstanceupdated', reportsDataItem_Updated);
    }

    mCache.RemoveItem('ReportFilters');
    mCache.unbind('ReportFiltersupdated', mStateManagerReportsLayout_PreInit);

    mCache.RemoveItem('ReportFilterInstance');
    mCache.unbind('ReportFilterInstanceupdated', mStateManagerReportsLayout_PreInit);

    mCache.RemoveItem('ReportGroupReport');
    mCache.unbind('ReportGroupReportupdated', mStateManagerReportsLayout_PreInit);

    mCache.RemoveItem('ReportAgent');
    mCache.unbind('ReportAgentupdated', mStateManagerReportsLayout_PreInit);

    if (!isNullOrUndefined(mReportsControls.CardView)) {
        mReportsControls.CardView.unbind('selectedchanged', mReportsCardView_OnSelectedChange);
        mReportsControls.CardView.unbind('databind', cardView_OnDataBind);
        mReportsControls.CardView.dispose();
        mReportsControls.CardView = null;
    }
    if (!isNullOrUndefined(mReportsControls.CardViewFilter)) {
        mReportsControls.CardViewFilter.dispose();
        mReportsControls.CardViewFilter = null;
    }
    if (!isNullOrUndefined(mReportsControls.CardViewPaginator)) {
        mReportsControls.CardViewPaginator.unbind('pagechanged', uReportsPaginator_OnPageChanged);
        mReportsControls.CardViewPaginator.dispose();
        mReportsControls.CardViewPaginator = null;
    }

    if (!isNullOrUndefined(mReportsControls.CardViewTimer)) {
        mReportsControls.CardViewTimer = null;
    }

    mReportsData.Clean = null;
    mReportsData.SchedulesClean = null;
    mReportsData.Dirty = null;
    mReportsData.Paginated = null;
    mReportsData.CurrentId = -1;

    mStateManagerReportsLayout_Leave(aPrevious, aCurrent);
}

function mStateManagerReportsLayout_Leave(aPrevious, aCurrent) {
    "use strict";

    if (!isNullOrUndefined(mReportsControls.ReportInstanceFiltersListView)) {
        mReportsControls.ReportInstanceFiltersListView.dispose();
        mReportsControls.ReportInstanceFiltersListView = null;
    }
    if (aCurrent.Settings[0] == 'Reports') {

        if (!isNullOrUndefined(mReportsControls.CardView)) {
            mReportsControls.CardView.unbind('selectedchanged', mReportsCardView_OnSelectedChange);
            mReportsControls.CardView.unbind('databind', cardView_OnDataBind);
            mReportsControls.CardView.dispose();
            mReportsControls.CardView = null;
        }
        if (!isNullOrUndefined(mReportsControls.CardViewFilter)) {
            mReportsControls.CardViewFilter.dispose();
            mReportsControls.CardViewFilter = null;
        }
        if (!isNullOrUndefined(mReportsControls.CardViewPaginator)) {
            mReportsControls.CardViewPaginator.unbind('pagechanged', uReportsPaginator_OnPageChanged);
            mReportsControls.CardViewPaginator.dispose();
            mReportsControls.CardViewPaginator = null;
        }
    } else {

        if (!isNullOrUndefined(mReportsControls.SchedulesCardView)) {
            mReportsControls.SchedulesCardView.unbind('selectedchanged', mReportsScheduleCardView_OnSelectedChange);
            mReportsControls.SchedulesCardView.unbind('databind', cardView_OnDataBind);
            mReportsControls.SchedulesCardView.dispose();
            mReportsControls.SchedulesCardView = null;
        }
        if (!isNullOrUndefined(mReportsControls.SchedulesCardViewFilter)) {
            mReportsControls.SchedulesCardViewFilter.dispose();
            mReportsControls.SchedulesCardViewFilter = null;
        }
        if (!isNullOrUndefined(mReportsControls.SchedulesCardViewPaginator)) {
            mReportsControls.SchedulesCardViewPaginator.unbind('pagechanged', uReportSchedulesPaginator_OnPageChanged);
            mReportsControls.SchedulesCardViewPaginator.dispose();
            mReportsControls.SchedulesCardViewPaginator = null;
        }
    }
}

/************************
new report list views for filters and emails - benjamin working here
*************************/

function uReportsScheduleFilterListView_Init() {
    "use strict";
    mReportsControls.ScheduleFilterListView = new sumo.controls.ListView('uReportsSchedulesListView', 'uReportsSchedulesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, [
            { 'id': 'RequiredFlag', 'title': localizeWrapper('cReportIsRequired'), 'dataField': 'RequiredFlag', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': IsRequiredFormatter },
          //  { 'id': 'ReportFilterName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'ReportFilterName', 'width': 'autoData', 'minWidth': 80, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'ReportFilterLabel', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'ReportFilterLabel', 'width': 'autoData', 'minWidth': 80, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'OverrideFlag', 'title': localizeWrapper('cEnrolleeOverride'), 'dataField': 'OverrideFlag', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': IsRequiredFormatter },
            { 'id': 'ReportFilterValue', 'title': localizeWrapper('cReportValue'), 'dataField': 'ReportFilterValue', 'width': 'autoData', 'minWidth': 80, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'ReportFilterText', 'title': localizeWrapper('cReportLabel'), 'dataField': 'ReportFilterText', 'width': 'autoData', 'minWidth': 80, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
    ]);
    mReportsControls.ScheduleFilterListView.bind('selectedchanged', uReportsScheduleFilterListView_OnSelectChange);

    mReportsControls.ScheduleFilterListView.setDataSource([]);
}

function uReportsScheduleFilterListView_OnSelectChange() {
    "use strict";
    var lSelected = mReportsControls.ScheduleFilterListView.selectedDataItem();

    if (lSelected.length == 1) {
        $('#uEditScheduleFilterButton').show();
        $('#uDeleteScheduleFilterButton').show();
    }else if(lSelected.length > 1){
        $('#uDeleteScheduleFilterButton').show();
        $('#uEditScheduleFilterButton').hide();
    } else {
        $('#uEditScheduleFilterButton').hide();
        $('#uDeleteScheduleFilterButton').hide();
    }


}

function uReportsScheduleEmailListView_Init() {
    "use strict";
    mReportsControls.ScheduleEmailListView = new sumo.controls.ListView('uReportsSchedulesListView', 'uReportsSchedulesListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, [
        { 'id': 'UserEmail', 'title': localizeWrapper('cAgentEmail'), 'dataField': 'UserEmail', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
    ]);
    mReportsControls.ScheduleEmailListView.bind('selectedchanged', uReportsScheduleEmailListView_OnSelectChange);


    mReportsControls.ScheduleEmailListView.setDataSource([]);
}

function uReportsScheduleEmailListView_OnSelectChange() {
    "use strict";
    var lSelectedLength = mReportsControls.ScheduleEmailListView.selected().length;

    if (lSelectedLength >= 1) {
        $('#uDeleteScheduleEmailButton').show();
    }
}

function uScheduleEmailAddButtonHide() {
    "use strict";
    if (!isNullOrUndefined(mReportsControls.ScheduleEmailListView)) {
        var lScheduleEmailList = mReportsControls.ScheduleEmailListView.getDataSource();
        if (lScheduleEmailList.length >= 1) {
            var lAgentId = mReportsControls.SchedulesCardView.selectedDataItem().AgentId,
                lBuilder = new SumoPredicateBuilder(),
                lAgent = getDataItem(lAgentId, 'Agents'),
                lAgentPrimaryEmail = lAgent.PrimaryEmail,
                lReportScheduleEmail;

            lBuilder.AddNewExpressionConditional('UserEmail', lAgentPrimaryEmail, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

            lReportScheduleEmail = query(lScheduleEmailList, lBuilder.RootExpression);

            if (lReportScheduleEmail.length >= 1) {
                $('#uAddScheduleEmailButton').hide();
            }
        }
        else {
            $('#uAddScheduleEmailButton').show();
        }
    }
}

function ReportsSchedules_Init() {
    "use strict";
    mReportsControls.SchedulesListView.setDataSource([]);
}

function getReportScheduleFilterFormat() {
    "use strict";
    return `
        <div>
            ${localizeWrapper('cReportScheduleFilterEdit')}
        </div>
        <table id="uReportScheduleFilterEdit">
            <tr>
                <td class="FormTitle">${localizeWrapper('cReportIsRequired')} </td>
                <td class="FormField"> <span id="uReportFilterIsRequired"></span> </td>
            </tr>
            <tr>
                <td class="FormTitle">${localizeWrapper('cEnrolleeDescription')} </td>
                <td class="FormField"> <span id="uReportFilterDescription"></span> </td>
            </tr>
            <tr>
                <td class="FormTitle">${localizeWrapper('cEnrolleeOverride')} </td>
                <td class="FormField"> <span id="uReportFilterOverride"></span> </td>
            </tr>
            <tr>
                <td class="FormTitle">${localizeWrapper('cReportValue')} </td>
                <td class="FormField" id="uReportFilterValueOuter"> <input type="text" class="Validate ValidateRequired" id="uReportFilterValue"/> </td>
            </tr>
            <tr>
                <td class="FormTitle">${localizeWrapper('cReportLabel')} </td>
                <td class="FormField" id="uReportFilterTextOuter"> <input type="text" class="Validate ValidateRequired" id="uReportFilterText"/> </td>
            </tr>
        </table>
    `;
}

function getReportScheduleFilterNewFormat() {
    "use strict";
    return `
        <div>
            ${localizeWrapper('cReportScheduleFilterEdit')}
        </div>
        <table id="uReportScheduleFilterEdit">
            <tr>
                <td class="FormTitle">${localizeWrapper('cReportIsRequired')} </td>
                <td class="FormField"> <span id="uReportFilterIsRequired"></span> </td>
            </tr>
            <!-- Commented out section
            <tr>
                <td class="FormTitle">${localizeWrapper('cEnrolleeName')} </td>
                <td class="FormField"> <span id="uReportFilterName"></span> </td>
            </tr>
            -->
            <tr>
                <td class="FormTitle">${localizeWrapper('cEnrolleeDescription')} </td>
                <td class="FormField"> <span id="uReportFilterDescription"></span> </td>
            </tr>
            <tr>
                <td class="FormTitle">${localizeWrapper('cEnrolleeOverride')} </td>
                <td class="FormField"> <span id="uReportFilterOverride"></span> </td>
            </tr>
        </table>
        <div id="uReportScheduleFiltersEdit">
            <input type="text" id="uReportFilterDescriptionValue"/>
        </div>
    `;
}

function uEditReportScheduleFilter_OnClick() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    var lReportFilter = mReportsControls.ScheduleFilterListView.selectedDataItem()[0];

    var lSelectedSchedule = mReportsControls.SchedulesCardView.selectedDataItem();

    var lOrganizationId = lSelectedSchedule.OrganizationId;

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveReportScheduleFilterButton_OnClick()').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()').appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cReportEditFilter'), getReportScheduleFilterNewFormat(), lButtonCommandBar, true, false);

    $('#uReportFilterIsRequired').html(IsRequiredFormatter(lReportFilter.RequiredFlag));
    $('#uReportFilterName').html(lReportFilter.ReportFilterName);
    $('#uReportFilterDescription').html(lReportFilter.ReportFilterLabel);
    $('#uReportFilterOverride').html(IsRequiredFormatter(lReportFilter.OverrideFlag));

    buildReportScheduleFilterPopup(lOrganizationId, lReportFilter.ReportFilterLabel);

    mReportsControls.ScheduleFilterValidator = new Validator('uReportScheduleFilterEdit', mRegexValidation);
}

function buildReportScheduleFilterPopup(aOrganizationId, aSelectedSchedule) {
    "use strict";
    var lReportId = mReportsControls.SchedulesCardView.selectedDataItem().ReportId,
        lReportAgents = getDataItems('ReportAgent'),
        lReportAgent,
        lKey,
        lBuilder = new SumoPredicateBuilder(),
        lOrganizationId = aOrganizationId,
        lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
        lSelectedSchedule = aSelectedSchedule;

    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lReportAgents = query(lReportAgents, lBuilder.RootExpression);

    for (lKey in lReportAgents) {
        if (lReportAgents.hasOwnProperty(lKey)) {
            lReportAgent = lReportAgents[lKey];
        }
    }

    callAjax('GetReportById', {
        'aSecurityToken': lSecurityToken,
        'aSecurityContextId': -1,
        'aReportId': lReportId,
        'aReportAgent': lReportAgent
    }, GetReportByID_OnSuccess, GetReportByID_OnFailure, lSelectedSchedule, false);

    function GetReportByID_OnSuccess(aParams, aData) {
        "use strict";
        var lReportInstance = aData,
            lParams = aParams,
            lPopulateHolder = RenderAndPopulatePopup(lReportInstance, 'uReportScheduleFiltersEdit', lParams);

        $('#uReportFilterDescriptionValue').val(lPopulateHolder);
    }

}

function RenderAndPopulatePopup(aReport, aContainer, aReportLabel) {
    "use strict";

    var lObject,
        i,
        lDescription = aReportLabel,
        lDescriptionType;
    for (i in aReport.Filter) {
        if (!isNullOrUndefined(aReport.Filter[i].FilterType)) {
            switch (aReport.Filter[i].FilterType) {
                case 1: case 2: //FilterTypeEnum.DATETEXTBOX:FilterTypeEnum.TEXTBOX
                    lObject = new TextBoxElement(aReport.Filter[i]);
                    break;
                case 3: case 4: //FilterTypeEnum.SINGLESELECT:FilterTypeEnum.MULTISELECT
                    lObject = new DropDownElement(aReport.Filter[i]);
                    break;
                default:
                    mActivityNotification.addNotification(localizeWrapper('cReportFilterUnknownError'));
                    break;
            }
            if (lDescription == aReport.Filter[i].LabelName) {
                lObject.Render(aContainer);
                lDescriptionType= aReport.Filter[i].FilterType;
            }
        }
    }
    return lDescriptionType;
}

function uSaveReportScheduleFilterButton_OnClick() {
    "use strict";
    var lDescription = $('#uReportFilterDescriptionValue').val();
    var lValueLabelHolder = getValueLabelOfReportScheduleFilter(lDescription);
    var lValue = lValueLabelHolder[0];
    var lLabel = lValueLabelHolder[1];
    var lReportFilter = mReportsControls.ScheduleFilterListView.selectedDataItem()[0];

    if (mReportsControls.ScheduleFilterValidator.IsValid()) {
        lReportFilter.ReportFilterValue = lValue;
        lReportFilter.ReportFilterText = lLabel;
        lReportFilter.TransactionId = moment().format("YYYYMMDDHHmmss");

        WriteSingle(lReportFilter, uSaveReportScheduleFilter_OnSuccess, Sad, null, true);
    }
}

function getValueLabelOfReportScheduleFilter(lDescription) {
    "use strict";
    var lValue,
        lLabel,
        lValueLabel = [];

    switch (lDescription) {
        case '1': case '2':
            lValue = $('#uReportScheduleFiltersEdit').find('input').val();
            lLabel = $('#uReportScheduleFiltersEdit').find('input').text();
            lValueLabel = [lValue, lLabel];
            break;
        case '3': case '4':
            lValue = $('#uReportScheduleFiltersEdit').find('select').val().toString();
            lLabel = $('#uReportScheduleFiltersEdit option:selected').html();
            lValueLabel = [lValue, lLabel];
            break;
        default:
            break;
    }

    return lValueLabel;
}

function uSaveReportScheduleFilter_OnSuccess(aParams, aData) {
    "use strict";
    ReloadScheduleFilter();
    mActivityNotification.addNotification(localizeWrapper('cSuccessExclamation'));
    ClosePopup();
}

function uDeleteReportScheduleFilter_OnClick() {
    "use strict";
    var lSelectedScheduleFilter = mReportsControls.ScheduleFilterListView.selectedDataItem();
    var lArrayIds = getArrayByIds(lSelectedScheduleFilter);
    var lBuilder = new SumoPredicateBuilder();
    var lFilters;
    var lKey;
    var lFilterList = [];

    lBuilder.AddNewExpressionConditional('Id', lArrayIds, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lFilters = query(mReportsData.ScheduleFilters, lBuilder.RootExpression);

    for (lKey in lFilters) {
        if (lFilters.hasOwnProperty(lKey)) {
            lFilters[lKey].IsActive = false;
            lFilters[lKey].TransactionId = moment().format("YYYYMMDDHHmmss");
            lFilterList.push(lFilters[lKey]);
        }
    }

    WriteMultiple(lFilterList, DeleteScheduleFilters_OnSuccess, Sad, null, true);
}

function ReloadScheduleFilter() {
    var lSelectedReportSchedule = mReportsControls.SchedulesCardView.selectedDataItem();

    $('#uDeleteScheduleFilterButton').hide();
    $('#uEditScheduleFilterButton').hide();
    PopulateReportScheduleFilters(lSelectedReportSchedule.Id);
}

function DeleteScheduleFilters_OnSuccess(aParams, aData) {
    "use strict";
    ReloadScheduleFilter();
    mActivityNotification.addNotification(localizeWrapper('cReportDeleteScheduleFilterSuccess'));
}
// add edit remove actions for report schedules
function uDeleteReportScheduleEmail_OnClick() {
    "use strict";
    var lSelectedScheduleEmail = mReportsControls.ScheduleEmailListView.selectedDataItem();

    lSelectedScheduleEmail.map(function (aEmail) {
        aEmail.IsActive = false;
        aEmail.TransactionId = moment().format("YYYYMMDDHHmmss");
    });

    WriteMultiple(lSelectedScheduleEmail, DeleteReportScheduleEmail_OnSuccess, Sad, null, true);
}


function DeleteReportScheduleEmail_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('IsActive', true, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    mReportsData.ScheduleEmails = query(mReportsData.ScheduleEmails, lBuilder.RootExpression);
    mReportsControls.ScheduleEmailListView.setDataSource(mReportsData.ScheduleEmails);
    uScheduleEmailAddButtonHide();
    $('#uDeleteScheduleEmailButton').hide();
    mActivityNotification.addNotification(localizeWrapper('cReportDeleteScheduleEmailSuccess'));
}


function uAddSaveReportScheduleEmailButton_OnClick() {
    "use strict";
    var lSelectedScheduleReport = mReportsControls.SchedulesCardView.selectedDataItem();
    var lAgentId = mReportsControls.SchedulesCardView.selectedDataItem().AgentId;
    var lAgent = getDataItem(lAgentId, 'Agents');
    var lEmail = 'befigenio@stopllc.com'; //lAgent.PrimaryEmail;
    var lScheduleEmail = new ReportScheduleEmail();


    lScheduleEmail.ReportScheduleId = lSelectedScheduleReport.Id;
    lScheduleEmail.UserEmail = lEmail;
    lScheduleEmail.TransactionId = moment().format("YYYYMMDDHHmmss");

    WriteSingle(lScheduleEmail, SaveReportScheduleEmail_OnSuccess, Sad, null, true);

}


function SaveReportScheduleEmail_OnSuccess(aParams, aData) {
    "use strict";
    var lKey;
    var lInserted = false;
    var lLocale = 'cReportAddScheduleEmailSuccess';
    for (lKey in mReportsData.ScheduleEmails) {
        if (mReportsData.ScheduleEmails.hasOwnProperty(lKey)) {
            if (aData.Id == mReportsData.ScheduleEmails[lKey].Id) {
                mReportsData.ScheduleEmails[lKey] = aData;
                lInserted = true;
                lLocale = 'cReportEditScheduleEmailSuccess';
            }
        }
    }

    if (!lInserted) {
        mReportsData.ScheduleEmails.push(aData);
    }

    mReportsControls.ScheduleEmailListView.setDataSource(mReportsData.ScheduleEmails);
    uScheduleEmailAddButtonHide();
    mActivityNotification.addNotification(localizeWrapper(lLocale));
}

function uAddReportScheduleButton_OnClick() {
    "use strict";
    var lSelected = mReportsControls.CardView.selectedDataItem();
    var lReportInstance = getDataItem(lSelected.Id, 'ReportInstance');

    mReportsData.SchedulesEditItem = new ReportSchedule();

    mReportsData.SchedulesEditItem.ReportScheduleName = ReportNameFormatter(lReportInstance.ReportName);
    mReportsData.SchedulesEditItem.ReportId = lSelected.ReportId;
    mReportsData.SchedulesEditItem.TypeCSVFlag = lReportInstance.IsCSV;
    mReportsData.SchedulesEditItem.TypeDOCFlag = lReportInstance.IsDOC;
    mReportsData.SchedulesEditItem.TypePDFFlag = lReportInstance.IsPDF;
    mReportsData.SchedulesEditItem.TypeRTFFlag = lReportInstance.IsRTF;
    mReportsData.SchedulesEditItem.TypeTXTFlag = lReportInstance.IsTXT;
    mReportsData.SchedulesEditItem.TypeXLSFlag = lReportInstance.IsXLS;

    ReportsSchedule_Init(localizeWrapper('cEnrolleeAddNewSchedule'), reportSchedulePopulate);
}

function ReportsSchedule_Init(aHeaderText, aCallback) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveReportScheduleButton_OnClick()').appendTo(lButtonCommandBar);
    GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()').appendTo(lButtonCommandBar);
    DisplayPopup(aHeaderText, '<div id="uScheduleDialogPanel"></div>', lButtonCommandBar, true, false);
    populateElement('uScheduleDialogPanel', 'Reports.Schedule.Popup.Layout.htm', function () { ReportsSchedule_OnComplete(aCallback); });

}

function DisableReportDocumentTypes(aId, aReport) {
    "use strict";
    var lKey;

    for(lKey in aReport){
        if(aReport.hasOwnProperty(lKey)){
            if (lKey.indexOf('Flag') !== -1) {
                if(!aReport[lKey])
                    $('#' + aId + lKey + 'Edit').prop('disabled', true);
            }
        }
    }

}

function ReportsSchedule_OnComplete(aCallback) {
    "use strict";
    var lReport = getDataItem(mReportsData.SchedulesEditItem.ReportId, 'Reports');

////    var lSelected = mReportsControls.CardView.selectedDataItem();
//    var lReportFilters = getReportFilterInstanceById(lSelected.Id);

//    if (!isNullOrUndefined(lReportFilters)) {
//        var lReportFilterType = reportFilterIsDateHelper(lReportFilters);
//        if (lReportFilterType == 1) {
//            $('#uReportScheduleReportScheduleDateIdEdit').prop("disabled", true).css('','#C0C0C0');
//            $('#uReportScheduleReportScheduleTimeIdEdit').prop("disabled", true).css('', '#C0C0C0');
//            $('#uReportScheduleReportScheduleTimeSpanIdEdit').prop("disabled", true).css('', '#C0C0C0');

//        }
//    }

    populateEditView(mReportsData.SchedulesEditItem, [
                     { 'Id': 'ReportScheduleDateId', 'Type': 'Dropdown', 'DataSource': ReportScheduleDailySortFormatter(),'LocaleName': 'ReportScheduleDate', 'DataValueField': 'Id', 'DataTextField': 'TimeSpanName' },
                     { 'Id': 'ReportScheduleTimeSpanId', 'Type': 'Dropdown', 'DataSource': ReportScheduleTimeSpanSortFormatter(),'LocaleName': 'ReportScheduleTimespan', 'DataValueField': 'Id', 'DataTextField': 'TimeSpanName' },
                     { 'Id': 'ReportScheduleTimeId', 'Type': 'Dropdown', 'DataSource': ReportScheduleTimeSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Times' },
                     { 'Id': 'EmailFormatId', 'Type': 'Dropdown', 'DataSource': getDataItems('EmailFormats'), 'LocaleName':'EmailFormat', 'DataValueField': 'Id', 'DataTextField': 'EmailFormatText' }
    ], {}, 'uReportSchedule', 'Edit', localizeDataItem);

    DisableReportDocumentTypes('uReportScheduleType', lReport);
    mReportsControls.SchedulesValidator = new Validator('uReportsSchedule', mRegexValidation);
}

function uSaveReportScheduleButton_OnClick() {
    "use strict";
    var lReport;
    if (mReportsControls.SchedulesValidator.IsValid()) {
        populateFromEditView(mReportsData.SchedulesEditItem, 'uReportSchedule', 'Edit');
        mReportsData.SchedulesEditItem.AgentId = mReportsControls.CardView.selectedDataItem().AgentId;
        mReportsData.SchedulesEditItem.OrganizationId = mReportsControls.CardView.selectedDataItem().OrganizationId;
        
        var lTransactionId = moment().format("YYYYMMDDHHmmss");
        mReportsData.SchedulesEditItem.TransactionId = lTransactionId;
        lReport = getDataItem(mReportsData.SchedulesEditItem.ReportId, 'Reports');

        mReportsData.SchedulesEditItem.ReportName = lReport.Name;

        var lCheckboxSelected = uEmailFormatIsSelected('uReportScheduleType', lReport);

        if (lCheckboxSelected) {
            //var lSelected = mReportsControls.CardView.selectedDataItem();
            //var lReportFilters = getReportFilterInstanceById(lSelected.Id);
            //if (isNullOrUndefined(lReportFilters)) {
            //    mReportsData.SchedulesEditItem.ReportScheduleTimeSpanId = 1;
            //}

            WriteSingle(mReportsData.SchedulesEditItem, saveReportScheduleFilters, null, lTransactionId, true);
        }
        else {
            mActivityNotification.addNotification(localizeWrapper('cFailScheduleAddSelectFormat'));
        }
    }
}

function uEmailFormatIsSelected(aId, aReport) {
    "use strict";
    var lKey;
    for (lKey in aReport) {
        if (aReport.hasOwnProperty(lKey)) {
            if (lKey.indexOf('Flag') !== -1) {
                    if ($('#' + aId + lKey + 'Edit').is(':checked')) {
                        return true;
                    }
            }
        }
    }
    return false;
}

function reportFilterIsDateHelper(aReportFilters) {
    "use strict";
    var lReportFilter = getDataItem(aReportFilters.ReportFilterId, 'ReportFilters'),
        lReportFilterType = lReportFilter.FilterType;

    return lReportFilterType;
}

function saveReportScheduleFilters(aParams, aData) {
    "use strict";
    var lTransactionId = aParams;
    var lSelected = mReportsControls.CardView.selectedDataItem();
    var lReportFilters = getReportFilterInstanceById(lSelected.Id);
    var lReportScheduleFilters = [];
    var lReportScheduleFilter;
    var lKey;
    if (aData) {
        setDataItem(aData.Id, 'ReportSchedules', aData);

        for (lKey in lReportFilters) {
            if (lReportFilters.hasOwnProperty(lKey)) {
                lReportScheduleFilter = new ReportScheduleFilter();
                lReportScheduleFilter.Id = parseInt(aData.Id.toString() + lReportFilters[lKey].ReportFilterId.toString());
                lReportScheduleFilter.ReportScheduleId = aData.Id;
                lReportScheduleFilter.ReportFilterId = lReportFilters[lKey].ReportFilterId;
                lReportScheduleFilter.ReportFilterValue = lReportFilters[lKey].Value;
                lReportScheduleFilter.ReportFilterText = lReportFilters[lKey].Text;
                lReportScheduleFilter.TransactionId = lTransactionId;

                lReportScheduleFilters.push(lReportScheduleFilter);
            }
        }
    }

    WriteMultiple(lReportScheduleFilters, ReportScheduleFilters_OnSuccess, null, aData, true);
}

function ReportScheduleFilters_OnSuccess(aParams, aData) {
    mActivityNotification.addNotification(localizeWrapper('cSuccessExclamation'));
    window.location.hash = "Reports.Schedules.Details.Filters." + aParams.Id;
    ClosePopup();
}

function uAddReportScheduleEmail_OnClick() {
    "use strict";

}

function getReportEmailInput(aId) {
    "use strict";


}

function reportSchedulePopulate(){}

function uEditReportSchedule_OnClick() {
    "use strict";
    var lSelected = mReportsControls.SchedulesListView.selectedDataItem();

    mReportsData.SchedulesEditItem = getDataItem(lSelected.Id, 'ReportSchedules');
    ReportsSchedule_Init(localizeWrapper('cEnrolleeAddNewSchedule'), reportSchedulePopulate);
}

function uDeleteReportSchedule_OnClick() {
    "use strict";
    var lSelectedIds = mReportsControls.SchedulesListView.selected(),
        lSchedules = getDataItems('ReportSchedules'),
        lScheduleList = [],
        lItem,
        lKey;

    for (lKey = 0; lKey < lSelectedIds.length; lKey++) {
        if (lSelectedIds.hasOwnProperty(lKey)) {
            lItem = lSchedules[lSelectedIds[lKey]];
            lItem.IsActive = false;
            lScheduleList.push(lItem);
        }
    }

    WriteMultiple(lScheduleList, null, null, null, true);
}

function uDeleteReportScheduleButton_OnClick() {
    "use strict";

    var lReportScheduleId = mReportsControls.SchedulesCardView.selectedDataItem().Id,
        lReportSchedule = getDataItem(lReportScheduleId, 'ReportSchedules');

    function reportSchedules_OnSuccess(aParams, aData) {
        mActivityNotification.addNotification(localizeWrapper('cReportScheduleDeleting') + ': ' + aData.ReportScheduleName);
        setDataItem(aData.Id, 'ReportSchedules', aData);
        ExitEditMode('uReportSchedulePanel');
        reportsScheduleDataListConverter();
        uReportSchedulesCardViewFilter_OnFilter();
    }


    lReportSchedule.IsActive = 0;
    lReportSchedule.TransactionId = moment().format("YYYYMMDDHHmmss");
    WriteSingle(lReportSchedule, reportSchedules_OnSuccess, null, null, true);
}

function OrganizationListLoad() {
    //Populate Drop Down
    var lBuilder = new SumoPredicateBuilder(),
        lOrganizations;

    lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);
    populateEditView({ 'OrganizationId': -1 }, [
        { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false }
    ], {}, 'uReports');
}



function reportsCache_Init(aCurrent) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lReportAgenBuilder = new SumoPredicateBuilder(),
        lAgentIdList = getMyAgentIds(gUserDetails.UserId);
    //below statement temporary fix until we see why .stop accounts do not have agents come back to UI
    if (lAgentIdList.length === 0)
        lAgentIdList.push(0);
    mReportsData.CacheItemsRemaining = 3;

    lReportAgenBuilder.AddNewExpressionConditional("UserId", gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    //The List of Variables needed to Display Appropriate Reports and build Dynamic Reports.
    mCache.bind('ReportAgentupdated', mStateManagerReportsLayout_PreInit, { 'Current': aCurrent, 'CacheItem': 'ReportAgent' });
    mCache.AddUpdatableItem('ReportAgent',
                            gObjectList.ReportAgent.AssemblyQualifiedName,
                            lReportAgenBuilder.RootExpression,
                            gCacheSettings.ReportAgentUpdateInterval,
                            null,
                            null);

    //List of Reports Completed in the past 7 days for the User in the current Schema.
    //lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    if (isNullOrUndefined(getViewState("LongRunningReport")) || isNullOrUndefined(getViewState("LongRunningReport").Value)) {
        lBuilder.AddNewExpressionConditional('AgentId', lAgentIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('Id', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
        mCache.bind('ReportInstanceupdated', mStateManagerReportsLayout_PreInit, { 'Current': aCurrent, 'CacheItem': 'ReportInstance' });
        mCache.AddUpdatableItem('ReportInstance',
                                gObjectList.ReportInstance.AssemblyQualifiedName,
                                lBuilder.RootExpression,
                                gCacheSettings.ReportInstanceUpdateInterval,
                                null,
                                null,
                                true);
    } else {
        mReportsData.CacheItemsRemaining--;
    }

    //List of Filters used in the Reports Completed in the Last 7 days.
    mCache.bind('ReportFilterInstanceupdated', mStateManagerReportsLayout_PreInit, { 'Current': aCurrent, 'CacheItem': 'ReportFilterInstance' });
    mCache.AddUpdatableItem('ReportFilterInstance',
                            gObjectList.ReportFilterInstance.AssemblyQualifiedName,
                            cacheItemUpdatable_Init,
                            gCacheSettings.ReportFilterInstanceUpdateInterval,
                            null,
                            null);


}

function loadReportsCacheInit(aCurrent) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    //The List of All the Filters for Reports.  Master Dapi.
    mCache.bind('ReportFiltersupdated', mStateManagerReportsLayout_PreInit, { 'Current': aCurrent, 'CacheItem': 'ReportFilters' });
    mCache.AddUpdatableItem('ReportFilters',
                            gObjectList.ReportFilter.AssemblyQualifiedName,
                            null,
                            gCacheSettings.ReportFilterUpdateInterval,
                            null,
                            null);

    //The List of Every Report in VT_REPORTS.  Master Dapi.
    mCache.bind('Reportsupdated', mStateManagerReportsLayout_PreInitLoaded, { 'Current': aCurrent, 'CacheItem': 'Reports' });
    mCache.AddUpdatableItem('Reports',
                            gObjectList.Report.AssemblyQualifiedName,
                            null,
                            gCacheSettings.ReportUpdateInterval,
                            null,
                            null);

    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ////The List of Report Groups and Reports.  Master Dapi.
    mCache.bind('ReportGroupReportupdated', mStateManagerReportsLayout_PreInit, { 'Current': aCurrent, 'CacheItem': 'ReportGroupReport' });
    mCache.AddUpdatableItem('ReportGroupReport',
                            gObjectList.ReportGroupReport.AssemblyQualifiedName,
                            lBuilder.RootExpression,
                            gCacheSettings.ReportGroupReportUpdateInterval,
                            null,
                            null);
}


//LIST
function reportsDataListConverter() {
    "use strict";
    var lReportInstances = getDataItems('ReportInstance'),
        lAgents = getDataItems('Agents'),
        lOrganizations = getDataItems('Organizations'),
        lReportInstance,
        lAgent,
        lOrganization,
        lReportInstanceCards = [],
        lKey,
        lSortPredicate = new SortExpression();

    for (lKey in lReportInstances) {
        if (lReportInstances.hasOwnProperty(lKey)) {
            lReportInstance = lReportInstances[lKey];
            lAgent = lAgents[lReportInstance.AgentId];
            if (!isNullOrUndefined(lAgent))
                lAgent = getDataItem(lReportInstance.AgentId, 'AgentsStop');
            lOrganization = lOrganizations[lReportInstance.OrganizationId];
            lReportInstanceCards[lReportInstance.Id] = new ReportCardView(lReportInstance, lAgent, lOrganization);
        }
    }

    lSortPredicate.addDescendingColumn('UpdatedUTC');
    lSortPredicate.addAscendingColumn('ReportName');

    lReportInstanceCards = lSortPredicate.sort(lReportInstanceCards);



    mReportsData.Clean = lReportInstanceCards;
    mReportsData.Dirty = null;
    mReportsData.Paginated = null;
}

function reportsScheduleDataListConverter() {
    "use strict";
    var lReportSchedules,
        lReport,
        lReportSchedule,
        lReportScheduleCards = [],
        lKey,
        lBuilder = new SumoPredicateBuilder(),
        lSortPredicate = new SortExpression();

    lBuilder.AddNewExpressionConditional('IsActive', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional('AgentId', getMyAgentIds(gUserDetails.UserId), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    lReportSchedules = query(getDataItems('ReportSchedules'), lBuilder.RootExpression);

    for (lKey in lReportSchedules) {
        if (lReportSchedules.hasOwnProperty(lKey)) {
            lReportSchedule = lReportSchedules[lKey];
            lReportScheduleCards[lReportSchedule.Id] = new ReportScheduleCardView(lReportSchedule, ReportDescriptionFormatter(lReportSchedule.ReportName));
        }
    }

    lSortPredicate.addAscendingColumn('ReportName');
    lReportScheduleCards = lSortPredicate.sort(lReportScheduleCards);

    mReportsData.SchedulesClean = lReportScheduleCards;
    mReportsData.Dirty = null;
    mReportsData.Sort = null;
    mReportsData.Paginated = null;
}


function reportsDataItem_Updated(aParams, aCache) {
    "use strict";
    var reportViewState = getViewState("LongRunningReport"),
        reportFound = false,
        reportIdsIndex = -1;

    if (!isNullOrUndefined(mReportsControls.CardView)) {
        if (mReportsData.SkipUpdateBar) {
            mReportsData.SkipUpdateBar = false;
            resetReportsCardView();
        }
        else if (UpdateViewOnReportsData()) { // can not use UpdateviewOnNewData() since ReportInstance data contract is not inheriting from CacheableBase
            mReportsControls.CardView.setUpdated(true);
        }
    }
 

    for (var lKey in aCache.Data) {
        if (aCache.Data.hasOwnProperty(lKey)) {
            if (!isNullOrUndefined(reportViewState) && !isNullOrUndefined(reportViewState.Value) && reportViewState.Value.indexOf(aCache.Data[lKey].Id) != -1 && aCache.Data[lKey].ReportStatus == 4) {
                reportFound = true;
                reportIdsIndex = reportViewState.Value.indexOf(aCache.Data[lKey].Id);
                break;
            }
        }
    }

    if (reportFound) {
        if (mStateManager.Tab() != "Reports") {
            mActivityNotification.addNotification(localizeWrapper('cReportFinishedProcessing'));
        }

        reportViewState.Value.splice(reportIdsIndex, 1);
        if (reportViewState.Value.length == 0) {
            setViewState("LongRunningReport", null);
            if (mStateManager.Tab() != "Reports") {
                mCache.RemoveItem('ReportInstance');
                mCache.unbind('ReportInstanceupdated', reportsDataItem_Updated);
            }
        } else {
            setViewState("LongRunningReport", reportViewState.Value);
        }
    }


}

function UpdateViewOnReportsData() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lOldData, //copy
        lNewData,
        lResult = false;

    reportsDataListConverter();
    lBuilder.AddNewExpressionConditional('ReportStatus', 'Processed', false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lOldData = query(mReportsData.StoredReports, lBuilder.RootExpression);
    lNewData = query(mReportsData.Clean, lBuilder.RootExpression);

    if (ObjectLength(lNewData) > ObjectLength(lOldData))
        lResult = true;

    return lResult
}

//BUTTON EVENTS
function uAddReportButton_OnClick() {
    "use strict";
    if(mReportsData.AddReportsReady)
    getFileHtml('Reports.Popup.Layout.htm', uReportsAddReport_OnLoad);
}

function uCancelReportButton_OnClick() {
    "use strict";
    ClosePopup();
}

function uReportsAddReport_OnLoad(aData) {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar(),
        loginOriList = [],
        oriKeyList = [],
        lItem,
        lKey,
        lSort = new SortExpression(),
        lOrganizations = [];

    lSort.addAscendingColumn('OriPath');
    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'uSaveReportButton_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);

    DisplayPopup(localizeWrapper('cReports'), aData, lButtonCommandBar, false);
    $('#uOrganizationsText').val(localizeText('cInventoryFindOrganization'));
    mReportsControls.OrganizationTreeControl = new VeritracksTreeDisplayController('uOrganizationHolder', { 'Overflow': false });

    lOrganizations = lSort.sort(getDataItems('Organizations'));
    for (lKey in lOrganizations) {
        if (lOrganizations.hasOwnProperty(lKey)) {
            lItem = lOrganizations[lKey];
            loginOriList.push(lItem);
            oriKeyList.push(lItem.Id);

        }
    }//end of for

    mReportsControls.OrganizationTreeControl.setDataSource(lSort.sort(getDataItems('Organizations')));
    mReportsControls.OrganizationTreeControl.buildGraphTree(loginOriList, oriKeyList);

    $('.SuperUserOrganization').change(reportOrganization_OnChangeTree).change();
    selectCurrentOrisTree(false);
    //Hide the Save until after a Report has been chosen.
    $('.PopupWindow .SaveButton').hide();
 //   BuildReportList();
}

function reportOrganization_OnChangeTree(aEvent) {
    var lValue = { 'Id': aEvent.target.defaultValue, 'checked': aEvent.target.checked };
    var mySelect = $('select[name=ddlChooseReport]');
    var lId = mySelect.val();

    $(".SuperUserOrganization").prop('checked', false);
    $('#' + mReportsData.ReportContainer).empty();
    if (lValue.checked) {
        $(this).prop('checked', true);
        BuildReportList(lValue.Id);
        mySelect = $('select[name=ddlChooseReport]');
        mySelect.val(lId).trigger('change');
    } else {
        mySelect.val(0);
    }
}

function OrganizationId_OnChange() {
    "use strict";

    mReportsData.CurrentOrganization = $('#uReportsOrganizationId').val();
}

function reportSchedulesCardViewSort(aParams, aSort) {
    "use strict";
    var lReports = mReportsData.SchedulesClean,
        lReportsSortedList = [];

    lReportsSortedList = aSort.sort(lReports);
    mReportsData.Sort = lReportsSortedList;
    mReportsControls.SchedulesCardViewFilter.filter();
}

function reportsCardViewSort(aParams, aSort) {
    "use strict";
    var lReports = mReportsData.Clean,
        lReportsSortedList = [];

    lReportsSortedList = aSort.sort(lReports);
    mReportsData.Sort = lReportsSortedList;
    mReportsControls.CardViewFilter.filter();
    //setViewState('ReportsCardViewSort', { 'column': aSort.Columns[0].ColumnName, 'direction': aSort.Columns[0].Direction });
}


function reportsCardView_Init() {
    "use strict";
   // if (isNullOrUndefined(mReportsControls.CardView)) {
        mReportsControls.CardView = new sumo.controls.CardView('uReportsCardView', 'uReportsListHolder', { 'cardTemplate': 'Interface/Reports.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'isSortable': true, 'Columns': [{ 'id': 'ReportName', 'title': localizeWrapper('cReportReportName') }] });
        mReportsControls.CardView.bind('selectedchanged', mReportsCardView_OnSelectedChange);
        mReportsControls.CardView.bind('sort', reportsCardViewSort);
        mReportsControls.CardView.bind('databind', cardView_OnDataBind);
        mReportsControls.CardView.bind('update', uReportsCardView_OnUpdate);
  //  }
    if (isNullOrUndefined(mReportsControls.CardViewFilter)) {
        gFilterFactory_OnReportsInit(gFilterFactory, null, null);
    } else {
        mReportsControls.CardViewFilter.render();
    }
    if (isNullOrUndefined(mReportsControls.CardViewPaginator)) {
        gPaginatorFactory_OnReportsInit();
    } else {
        mReportsControls.CardViewPaginator.render();
        mReportsControls.CardViewPaginator.trigger('pagechanged');
    }
}

function reportsScheduleCardView_Init() {
    "use strict";
    mReportsData.SchedulesClean = null;
    mReportsData.Dirty = null;
    mReportsData.Sort = null;
    mReportsData.Paginated = null;
     if (isNullOrUndefined(mReportsControls.SchedulesCardView)) {
         mReportsControls.SchedulesCardView = new sumo.controls.CardView('uReportSchedulesCardView', 'uReportsListHolder', { 'cardTemplate': 'Interface/Reports.Schedule.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'isSortable': true, 'Columns': [{ 'id': 'ScheduleName', 'title': localizeWrapper('cReportsScheduleName') }] });
        mReportsControls.SchedulesCardView.bind('selectedchanged', mReportsScheduleCardView_OnSelectedChange);
        mReportsControls.SchedulesCardView.bind('sort', reportSchedulesCardViewSort);
        mReportsControls.SchedulesCardView.bind('databind', cardView_OnDataBind);
        mReportsControls.SchedulesCardView.bind('update', uReportSchedulesCardView_OnUpdate);
    }
    if (isNullOrUndefined(mReportsControls.SchedulesCardViewFilter)) {
        gFilterFactory_OnReportsSchedulesInit(gFilterFactory, null, null);
    } else {
        mReportsControls.SchedulesCardViewFilter.render();
    }
    if (isNullOrUndefined(mReportsControls.SchedulesCardViewPaginator)) {
        gPaginatorFactory_OnReportSchedulesInit();
    } else {
        mReportsControls.SchedulesCardViewPaginator.render();
        mReportsControls.SchedulesCardViewPaginator.trigger('pagechanged');
    }
}

function mReportsScheduleCardView_OnSelectedChange(aSender, aSelectedKey, aData) {
    "use strict";
    var lReportsCount,
        lSelectedReport = mReportsControls.SchedulesCardView.selectedDataItem(),
        lItem,
        lKey;
    if (!isNullOrUndefined(lSelectedReport)) {
        veritracks.security.controller.extendSession();
        mReportsData.CurrentId = lSelectedReport.Id;
        mReportsControls.CardViewTimer.SetTimer(function () {
            reportScheduleExitEditMode();
            PopulateReportScheduleData(mReportsData.CurrentId);
            window['mStateManagerReportsSecondary' + mStateManager.Settings()[2] + '_Init'](lSelectedReport.Id);
            uScheduleEmailAddButtonHide();
        });

    }

}

function PopulateReportScheduleFilters(aId) {
    "use strict";
    var lBuilder;

    if(mReportsControls.ScheduleFilterListView){
        lBuilder = new SumoPredicateBuilder();


        lBuilder.AddNewExpressionConditional('ReportScheduleId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        //  lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.ReportScheduleFilter.AssemblyQualifiedName, lBuilder.RootExpression, 0, PopulateReportScheduleFiltersSuccess, null, null);
    }
}

function PopulateReportScheduleFiltersSuccess(aParams, aData) {
    "use strict";
    var lReportFilterListViewDataList = [],
    lReportFilterListViewData,
    lReportFilterInstance,
    lReportFilters = getDataItems('ReportFilters'),
    lReportFilter,
    lKey;

    mReportsData.ScheduleFilters = aData;

    mReportsData.ScheduleFiltersDirty = aData;
    mReportsControls.ScheduleFilterListView.setDataSource(mReportsData.ScheduleFiltersDirty);
}

function PopulateReportScheduleEmails(aId) {
    "use strict";
    var lBuilder;

    if(mReportsControls.ScheduleEmailListView){
        lBuilder = new SumoPredicateBuilder();

        lBuilder.AddNewExpressionConditional('ReportScheduleId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        // lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.ReportScheduleEmail.AssemblyQualifiedName, lBuilder.RootExpression, 0, PopulateReportScheduleEmailsSuccess, null, null);
    }
}

function PopulateReportScheduleEmailsSuccess(aParams, aData) {
    "use strict";
    mReportsData.ScheduleEmails = aData;
    mReportsControls.ScheduleEmailListView.setDataSource(mReportsData.ScheduleEmails);
    uScheduleEmailAddButtonHide();

}

function mReportsCardView_OnSelectedChange(aSender, aSelectedKey, aData) {
    "use strict";
    var lReportsCount,
        lSelectedReport = mReportsControls.CardView.selectedDataItem(),
        lReport,
        lItem,
        lKey;
    if (!isNullOrUndefined(lSelectedReport)) {
        veritracks.security.controller.extendSession();
        mReportsData.CurrentId = lSelectedReport.Id;
        lReport = getDataItem(lSelectedReport.ReportId, 'Reports');

        if (lReport && lReport.ReportScheduleFlag) {
            $('#uAddReportScheduleButton').show();
        } else {
            $('#uAddReportScheduleButton').hide();
        }


        mReportsControls.CardViewTimer.SetTimer(function () {
            uCancelReportButton_OnClick();
            PopulateReportData(mReportsData.CurrentId);
        });
    }
}

function uReportsCardView_OnUpdate() {
    "use strict";
    mReportsControls.CardViewFilter.filter();
}

function uReportSchedulesCardView_OnUpdate() {
    mReportsControls.SchedulesCardViewFilter.filter();
}

function gFilterFactory_OnReportsSchedulesInit(aSender, aEvent, aData) {
    "use strict";
    var lUserPreferences = getUserPreferences(7);

    mReportsControls.SchedulesCardViewFilter = aSender.createControl(
        'uReportsCardViewFilter',
        'uReportsListFilterHolder',
        {
            'Title': localizeWrapper('cReportFindSchedules'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uReportSchedulesCardViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'ReportScheduleName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'ScheduleName' },
                { 'Id': 'EmailFormatId', 'Title': localizeWrapper('cReportEmailFormat'), 'Type': 'Dropdown', 'DataField': 'EmailFormat', 'DataSource': getDataItems('EmailFormats'), 'LocaleName': 'EmailFormat', 'DataTextField': 'EmailFormatText', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'Agency', 'Title': localizeWrapper('cEnrolleeAgency'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': OrganizationSortFormatter(), 'DataTextField': 'Name', 'DataValueField': 'Id', 'InsertBlank': true, 'BlankText': localizeText('cAll') }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 7,
            'LocalizableMethod': localizeDataItem
        });
}

function gFilterFactory_OnReportsInit(aSender, aEvent, aData) {
    "use strict";
    var lUserPreferences = getUserPreferences(7),
    lOrganizations = OrganizationSortFormatter(),
    lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lOrganizations = query(lOrganizations, lBuilder.RootExpression);

    mReportsControls.CardViewFilter = aSender.createControl(
        'uReportSchedulesCardViewFilter',
        'uReportsListFilterHolder',
        {
            'Title': localizeWrapper('cReportFindReports'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': uReportsCardViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'ReportName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'ReportName' },
                { 'Id': 'ReportDescription', 'Title': localizeWrapper('cEnrolleeDescription'), 'Type': 'Text', 'DataField': 'ReportDescription' },
                { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'InsertBlank': true, 'BlankText': localizeText('cAll'), 'relationalOperator': mRelationalOperatorEnum.Equal(), 'ComparisonType': 'integer' },
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 7
        });
}

function gPaginatorFactory_OnReportSchedulesInit(aSender, aEventData, aData) {
    "use strict";
    mReportsControls.SchedulesCardViewPaginator = new sumo.controls.Paginator('uReportsPaginator', 'uReportsPagerHolder', {
        'ItemCount': count(mReportsData.SchedulesClean),
        'ItemsPerPage': gPaginationSettings.ReportsItems
    });


    mReportsControls.SchedulesCardViewPaginator.bind('pagechanged', uReportSchedulesPaginator_OnPageChanged);
}

function gPaginatorFactory_OnReportsInit(aSender, aEventData, aData) {
    "use strict";

    mReportsControls.CardViewPaginator = new sumo.controls.Paginator('uReportsPaginator', 'uReportsPagerHolder', {
        'ItemCount': count(mReportsData.Clean),
        'ItemsPerPage': gPaginationSettings.ReportsItems
    });


    mReportsControls.CardViewPaginator.bind('pagechanged', uReportsPaginator_OnPageChanged);
    //mReportsControls.CardViewFilter.filter();
}

function uReportSchedulesCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder,
    lSortPredicate = new SortExpression(),
    lIsEmpty;
    // lSortPredicate.addDescendingColumn('Id');
    lSortPredicate.addAscendingColumn('ReportName');

    if (isNullOrUndefined(mReportsData.SchedulesClean)) {
        mReportsData.SchedulesClean = [];
    }
    else {
        mReportsData.Sort = mReportsData.SchedulesClean;
    }


    if (isNullOrUndefined(mReportsData.Sort)) {
        mReportsData.Sort = mReportsData.SchedulesClean;
    }

    if (mReportsData.TargetId === -1) {
        mReportsData.Dirty = lSortPredicate.sort(query(mReportsData.Sort, aExpression));
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mReportsData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mReportsData.Dirty = lSortPredicate.sort(query(mReportsData.Sort, lBuilder.RootExpression));
        mReportsData.TargetId = -1;
    }

    if (mReportsData.Dirty.length === 0) {
        lIsEmpty = (mReportsData.Dirty.length === 0);
        //mReportsData.Dirty = lSortPredicate.sort(copyArray(mReportsData.Clean));
        mActivityNotification.addNotification(localizeWrapper('cReportNoItemsForFilter'));
    }

    veritracks.system.applyFilterState('ReportSchedules', lIsEmpty);
    mReportsData.StoredReports = mReportsData.Dirty;
    mReportsData.Paginated = mReportsControls.SchedulesCardViewPaginator.paginate(mReportsData.Dirty);
    mReportsControls.SchedulesCardView.setDataSource(mReportsData.Paginated);
}

function uReportsCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder,
    lSortPredicate = new SortExpression(),
    lIsEmpty;
    lSortPredicate.addDescendingColumn('UpdatedUTC');
    lSortPredicate.addAscendingColumn('ReportName');

    if (isNullOrUndefined(mReportsData.Clean)) {
        mReportsData.Clean = [];
    }
    else {
        mReportsData.Sort = mReportsData.Clean;
    }


    if (isNullOrUndefined(mReportsData.Sort)) {
        mReportsData.Sort = mReportsData.Clean;
    }

    if (mReportsData.TargetId === -1) {
        mReportsData.Dirty = lSortPredicate.sort(query(mReportsData.Sort, aExpression));
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mReportsData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mReportsData.Dirty = lSortPredicate.sort(query(mReportsData.Sort, lBuilder.RootExpression));
        mReportsData.TargetId = -1;
    }

    if (mReportsData.Dirty.length === 0) {
        lIsEmpty = (mReportsData.Dirty.length === 0);
        //mReportsData.Dirty = lSortPredicate.sort(copyArray(mReportsData.Clean));
        mActivityNotification.addNotification(localizeWrapper('cReportNoItemsForFilter'));
    } else {
        mActivityNotification.addNotification(localizeWrapper('cReportLoading'));
    }

    veritracks.system.applyFilterState('Reports', lIsEmpty);
    mReportsData.StoredReports = mReportsData.Dirty;
    mReportsData.Paginated = mReportsControls.CardViewPaginator.paginate(mReportsData.Dirty);
    mReportsControls.CardView.setDataSource(mReportsData.Paginated);
}

function uReportSchedulesPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mReportsData.Dirty)) {
        mReportsData.Dirty = mReportsData.SchedulesClean;
    }
    if (!isNullOrUndefined(mReportsData.Dirty)) {
        mReportsData.Paginated = aSender.paginate(mReportsData.Dirty);
        mReportsControls.SchedulesCardView.setDataSource(mReportsData.Paginated);
    }
}

function uReportsPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mReportsData.Dirty)) {
        mReportsData.Dirty = mReportsData.Clean;
    }
    if (!isNullOrUndefined(mReportsData.Dirty)) {
        mReportsData.Paginated = aSender.paginate(mReportsData.Dirty);
        mReportsControls.CardView.setDataSource(mReportsData.Paginated);
    }
}

function PopulateReportScheduleData(aReportScheduleId) {
    "use strict";
    var lReportSchedule;
    if (!isNullOrUndefined(mReportsControls.SchedulesCardView)) {
        var lCard = mReportsControls.SchedulesCardView.selectedDataItem();
        lReportSchedule = getDataItem(aReportScheduleId, 'ReportSchedules');
        ExitEditMode('uReportSchedulePanel');
        PopulateDetailView(lReportSchedule, {
            'ReportScheduleName': null,
            'ReportScheduleDateId': reportScheduleDateFormatter,
            'ReportScheduleTimeId': reportScheduleTimeFormatter,
            'ReportScheduleTimeSpanId': reportScheduleTimeSpanFormatter,
            'EmailFormatId': reportEmailFormatFormatter,
            'TypeCSVFlag': reportEnabledFormatter,
            'TypeDOCFlag': reportEnabledFormatter,
            'TypePDFFlag': reportEnabledFormatter,
            'TypeRTFFlag': reportEnabledFormatter,
            'TypeTXTFlag': reportEnabledFormatter,
            'TypeXLSFlag': reportEnabledFormatter,
            'OrganizationId': OrganizationNameFormatter
        }, 'uSchedule');
    }
}

function uSaveReportScheduleEditButton_OnClick() {
    "use strict";
    var lCard = mReportsControls.SchedulesCardView.selectedDataItem();
    var lReportSchedule = getDataItem(lCard.Id, 'ReportSchedules');
    populateFromEditView(lReportSchedule, 'uSchedule', 'Edit');
    lReportSchedule.TransactionId = moment().format("YYYYMMDDHHmmss");
    //Vulnerability 3258
    lReportSchedule.ReportScheduleName = veritracks.system.encodeHtml(lReportSchedule.ReportScheduleName);
    WriteSingle(lReportSchedule, saveReportSchedule_OnSuccess, null, null, true);
}

function uCancelReportScheduleButton_OnClick() {
    "use strict";
    reportScheduleExitEditMode();
}

function saveReportSchedule_OnSuccess(aParams, aData) {
    "use strict";

    setDataItem(aData.Id, 'ReportSchedules', aData);
    reportScheduleExitEditMode();
    PopulateReportScheduleData(aData.Id);
}

function uEditReportScheduleButton_OnClick() {
    "use strict";
    EnterEditMode('uReportSchedulePanel');

    $('#uEditReportScheduleButton').hide();
    $('#uSaveReportScheduleButton').show();
    $('#uCancelReportScheduleButton').show();
    reportScheduleEnterEditMode();
}

function reportScheduleExitEditMode() {
    "use strict";
    if (mReportsControls.SchedulesCardView.getDataSource().length > 0) {
        ExitEditMode('uReportSchedulePanel');
        $('#uSaveReportScheduleButton').hide();
        $('#uCancelReportScheduleButton').hide();
        $('#uEditReportScheduleButton').show();
        $('#uDeleteReportScheduleButton').show();
    }
    else {
        $('#uSaveReportScheduleButton').hide();
        $('#uCancelReportScheduleButton').hide();
        $('#uEditReportScheduleButton').hide();
        $('#uDeleteReportScheduleButton').hide();
    }

}

function reportScheduleEnterEditMode() {
    "use strict";
    var lSelected = mReportsControls.SchedulesCardView.selectedDataItem();
    var lReportSchedule = getDataItem(lSelected.Id, 'ReportSchedules');
    var lReport = getDataItem(lReportSchedule.ReportId, 'Reports');

    populateEditView(lReportSchedule, [
                 { 'Id': 'ReportScheduleDateId', 'Type': 'Dropdown', 'DataSource': ReportScheduleDailySortFormatter(), 'LocaleName': 'ReportScheduleDate', 'DataValueField': 'Id', 'DataTextField': 'TimeSpanName' },
                 { 'Id': 'ReportScheduleTimeSpanId', 'Type': 'Dropdown', 'DataSource': ReportScheduleTimeSpanSortFormatter(), 'LocaleName': 'ReportScheduleTimeSpan', 'DataValueField': 'Id', 'DataTextField': 'TimeSpanName' },
                 { 'Id': 'ReportScheduleTimeId', 'Type': 'Dropdown', 'DataSource': ReportScheduleTimeSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Times' },
                 { 'Id': 'EmailFormatId', 'Type': 'Dropdown', 'DataSource': getDataItems('EmailFormats'), 'LocaleName': 'EmailFormat', 'DataValueField': 'Id', 'DataTextField': 'EmailFormatText' }
    ], {'ReportScheduleName':veritracks.system.decodeHtml}, 'uSchedule', 'Edit', localizeDataItem);
    DisableReportDocumentTypes('uScheduleType', lReport);
  //  DisableTimeRelatedSelect(lReportSchedule);
    mReportsControls.SchedulesValidator = new Validator('uReportSchedulePanel', mRegexValidation);
}

function DisableTimeRelatedSelect(aReportSchedule) {
    "use strict";
    var lReportSchedule = aReportSchedule;

    var lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('ReportScheduleId', lReportSchedule.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //  lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.ReportScheduleFilter.AssemblyQualifiedName, lBuilder.RootExpression, 0, PopulateReportScheduleTimeFilter, null, null);
}

function PopulateReportScheduleTimeFilter(aParam, aData) {
    "use strict";

    var lReportFilterId,
        lReportFilters,
        lReportScheduleFilter,
        lKey,
        lDateTypes = [];

    if (!isNullOrUndefined(aData)) {
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lReportScheduleFilter = new ReportScheduleFilter();
                lReportScheduleFilter.ReportFilterId = aData[lKey].ReportFilterId;
                var lReportFilter = getDataItem(lReportScheduleFilter.ReportFilterId, 'ReportFilters');
                if (!isNullOrUndefined(lReportFilter)) {
                    if (lReportFilter.FilterType == 1) {
                        lDateTypes.push(lReportFilter.FilterType);
                    }
                }
            }
        }
    }

    if (lDateTypes.length >= 1) {
        $('#uScheduleReportScheduleDateIdEdit').prop('disabled', true).css('background', '#C0C0C0');
        $('#uScheduleReportScheduleTimeIdEdit').prop('disabled', true).css('background', '#C0C0C0');
        $('#uScheduleReportScheduleTimeSpanIdEdit').prop('disabled', true).css('background', '#C0C0C0');
    }
}

function reportEnabledFormatter(aId) {
    "use strict";
    var lEnabled = localizeText('cDisabled');

    if (aId) {
        lEnabled = localizeText('cEnabled');
    }
    return lEnabled;
}

function PopulateReportData(aReportInstanceId) {
    "use strict";
    if (!isNullOrUndefined(mReportsControls.CardView)) {
        var lCard = mReportsControls.CardView.selectedDataItem();
        if (lCard.ReportDescription == null || lCard.ReportDescription == '') {
            var lReports = getDataItems('Reports');
            lCard.ReportDescription = lReports[lCard.ReportId].Description;
        }
        PopulateDetailView(lCard, {
            'OrganizationId': OrganizationNameFormatter,
            'AgentId': AgentNameFormatter,
            'ReportGeneratedDate': DisplayDate,
            'UpdatedUTC': DisplayDate,
            'ReportName': null,
            'ReportDescription': ReportDescriptionFormatter,
            'ReportStatus': null,
            'DOCStatus': reportStatusFormatter,
            'PDFStatus': reportStatusFormatter,
            'XLSStatus': reportStatusFormatter,
            'RTFStatus': reportStatusFormatter,
            'TXTStatus': reportStatusFormatter,
            'CSVStatus': reportStatusFormatter,
            'DOCURL': null,
            'PDFURL': null,
            'XLSURL': null,
            'RTFURL': null,
            'TXTURL': null,
            'CSVURL': null
        }, 'uInstance');

        reportInstanceFilters_Populate();
    }
}

function reportInstanceFilters_Init() {
    "use strict";
    if (isNullOrUndefined(mReportsControls.ReportInstanceFiltersListView)) {
        var lColumns = [
            { 'id': 'LabelName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'LabelName', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'cssClass': null, 'formatMethod': null, 'canResize': false },
            { 'id': 'IsRequired', 'title': localizeWrapper('cReportIsRequired'), 'dataField': 'IsRequired', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'formatMethod': IsRequiredFormatter, 'canResize': false },
            { 'id': 'Text', 'title': localizeWrapper('cReportValue'), 'dataField': 'Text', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'formatMethod': null, 'canResize': false }
        ];

        mReportsControls.ReportInstanceFiltersListView = new sumo.controls.ListView('uInstanceReportFilterListView', 'uInstanceReportFilterListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);
    }
}

function getReportFilterInstanceById(aId) {
    var lReportFilterInstances = getDataItems('ReportFilterInstance'),

    lBuilder = new SumoPredicateBuilder();

    lBuilder.AddNewExpressionConditional('ReportInstanceId', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lReportFilterInstances = query(lReportFilterInstances, lBuilder.RootExpression);

    return lReportFilterInstances;
}

function reportInstanceFilters_Populate() {
    "use strict";
    if (!isNullOrUndefined(mReportsControls.ReportInstanceFiltersListView)) {
        var lCard = mReportsControls.CardView.selectedDataItem();
        if (!isNullOrUndefined(lCard)) {

            var lReportFilterListViewDataList = [],
            lReportFilterListViewData,
            lReportFilterInstance,
            lReportFilterInstances = getReportFilterInstanceById(lCard.Id),
            lReportFilters = getDataItems('ReportFilters'),
            lReportFilter,
            lKey;

            for (lKey in lReportFilterInstances) {
                if (lReportFilterInstances.hasOwnProperty(lKey)) {
                    lReportFilterInstance = lReportFilterInstances[lKey];
                    if (!isNullOrUndefined(lReportFilters)) {
                        lReportFilter = lReportFilters[lReportFilterInstance.ReportFilterId];
                        lReportFilterListViewDataList[lReportFilterInstance.Id] = new ReportFilterListViewData(lReportFilter.LabelName, lReportFilter.IsRequired, lReportFilterInstance.Text);
                    }

                }
            }
            mReportsControls.ReportInstanceFiltersListView.setDataSource(lReportFilterListViewDataList);
            CreateReportLinks();
        }
    }
}

function CreateReportLinks() {
    "use strict";

    var lURL, lDisplayText;
    lDisplayText = localizeText('cReportOpenDocument');
    $(".pReportsDetailsProfile .ReportURL").each(function (aIndex, aElement) {
        $(aElement).find('a').remove();

        if ($(aElement).text().length > 0) {
            lURL = mReportsData.ReportURLPrepend + $(aElement).text();
            $(aElement).text('');
            $(aElement).append($("<a />").attr({ "class": "reportLinks", "href": lURL, "target": "_blank" }).html(lDisplayText));
        }
    });

}
//!******************************************************************
//!*********** ADD REPORT DYNAMIC FORM ******************************
function BuildReportList(aOrganizationId) {
    "use strict";

    mReportsControls.ReportInstance = new ReportInstance();

    //Get Report Variables
    //Refactor and move all vars to one place
    var lReportList = new ReportList(),
    lReportAgents = getDataItems('ReportAgent'),
    lReportGroupReports = getDataItems('ReportGroupReport'),
    lReports = getDataItems('Reports'),
    lReportAgent,
    lReportIdList = [],
    lReportGroup,
    lKey,
    lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
    lItem,
    lBuilder = new SumoPredicateBuilder();

    //Get the ReportAgent record with values needed to build the Report List and populate the Dynamic SQL.
    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', aOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lReportAgents = query(lReportAgents, lBuilder.RootExpression);

    for (lKey in lReportAgents) {
        if (lReportAgents.hasOwnProperty(lKey)) {
            lReportAgent = lReportAgents[lKey];
        }
    }

    //Get the Report Ids for the Report Group the User has access too.
    lKey = null;
    lBuilder.Clear();

    // .stop accounts all are -1
    //if (lReportAgent.ReportGroupId !== -1) {
        lBuilder.AddNewExpressionConditional('GroupId', lReportAgent.ReportGroupId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
  //  }

    lReportGroupReports = query(lReportGroupReports, lBuilder.RootExpression);

    for (lKey in lReportGroupReports) {
        if (lReportGroupReports.hasOwnProperty(lKey)) {
            lReportGroup = lReportGroupReports[lKey];
            if (lReportIdList.indexOf(lReportGroup.Id) === -1) {
                lReportIdList.push(lReportGroup.ReportId);
            }
        }
    }

    //Get User's list of Reports
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', lReportIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());

    var lSortPredicate = new SortExpression();
    lSortPredicate.addAscendingColumn('Name');
    lReports = lSortPredicate.sort(query(lReports, lBuilder.RootExpression));

    for (lKey in lReports) {
        if (lReports.hasOwnProperty(lKey)) {
            lItem = lReports[lKey];
            lReportList.Options[lKey] = new Options(lItem.Id, lItem.Name);
        }
    }

    lReportList.Options.unshift(new Options(0, localizeText('cPleaseSelect')));
    var lObject = new DropDownElement(lReportList).Render(mReportsData.ReportContainer);
   

    //Hide the Save until after a Report has been chosen.
    $('.PopupWindow .SaveButton').hide();


    $('#' + lReportList.Id).change(function () {
        var lReportId = parseInt($(this).val());
        //$('#uReports').empty();
        callAjax('GetReportById', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aReportId': lReportId,
            'aReportAgent': lReportAgent
        }, GetReportByID_OnSuccess, GetReportByID_OnFailure, 0, false);
    });
}


function BuildReport(aData) {
    "use strict";

    //Clear the container, clear the objects.
    $('#' + mReportsData.Container).empty(); //Clear the container before adding new controls.
    $('#' + mReportsData.ReportContainer).find('#lblReportDescription').remove(); //Clear the Report Description
    $('#' + mReportsData.ReportContainer).find('#lblSendEmail').remove(); //Clear the Send Email Label
    $('#' + mReportsData.ReportContainer).find('#chkSendEmail').remove(); //Clear the Send Email Checkbox

    mReportsControls.ReportInstance = new ReportInstance(); //Clear the report object before adding new data
    mReportsControls.ReportInstance.ReportValidator = new Validator(mReportsData.Container, mRegexValidation); //Add the Report Validator here.

    var lReportInstance = aData;
    mReportsControls.ReportInstance.Id = lReportInstance.Id;
    mReportsControls.ReportInstance.ReportId = lReportInstance.ReportId;
    mReportsControls.ReportInstance.AgentId = lReportInstance.AgentId;

    var lReports = getDataItems('Reports');
    if (!isNullOrUndefined(lReportInstance) && lReportInstance.Id > 0) {
        mReportsControls.ReportInstance.ReportName = lReports[lReportInstance.Id].Name;
        mReportsControls.ReportInstance.ReportDescription = lReports[lReportInstance.Id].Description;
        CreateLabel('ReportDescription', mReportsControls.ReportInstance.ReportDescription, mReportsData.ReportContainer);
        CreateCheckBox('SendEmail', 'Send Email', mReportsData.ReportContainer);
        $('.PopupWindow .SaveButton').show(); //Show Save After Report Selection.

    }
    else {
        $('.PopupWindow .SaveButton').hide();
    }


    RenderAndPopulate(lReportInstance, mReportsData.Container);

    $('#17310').change(function () {
        var lAgentId = parseInt($(this).val()),
        lBuilder = new SumoPredicateBuilder(),
        lEnrollees = getDataItems('Enrollees'),
        lMyEnrollees,
        lMyEnrolleesList = [];
        if (lAgentId === 0) {
            for(var key in lReportInstance.Filter){

                if (lReportInstance.Filter.hasOwnProperty(key)) {
                    var filter = lReportInstance.Filter[key];
                    if (filter.Id === 17320) {
                        PopulateFilter(filter, '17320');
                    }
                }
            }
            $('.PopupWindow .SaveButton').show();
        }
        else {
            if ($('#17320').length) {
                $('#17320').empty();
                lBuilder.AddNewExpressionConditional('AgentId', lAgentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

                lMyEnrollees = query(lEnrollees, lBuilder.RootExpression);

                for (var lKey in lMyEnrollees) {
                    if (lMyEnrollees.hasOwnProperty(lKey)) {
                        var lEnrollee = lMyEnrollees[lKey];

                        $('#17320').append($('<option>', {
                            value: lEnrollee.Id,
                            text: lEnrollee.FullName + " - " + lEnrollee.Id
                        }));
                        //.html("<option value='" + lEnrollee.Id + "'>"+ lEnrollee.FullName + lEnrollee.Id + "</option>");
                        lMyEnrolleesList.push(lEnrollee);
                    }
                }
                if (lMyEnrolleesList.length == 0) {
                    $('.PopupWindow .SaveButton').hide();
                }
                else {
                    $('.PopupWindow .SaveButton').show();
                }
            }
        }
    });
}

function PopulateFilter(aFilter, aContainer) {
    "use strict";
    $('#' + aContainer).empty();
        $.each(aFilter.Options, function (id, data) {
            $('#' + aContainer).append($('<option>', {
                value: data.Id,
                text: data.Value
            }));
        });
        $('#' + aContainer + ' option:first-child').attr("selected", "selected");
}

function resetReportsCardView() {
    "use strict";
    reportsDataListConverter();
    mReportsControls.CardViewFilter.filter();
    //mEnrolleesControls.CardView.bind('databind', enrolleesResetOffenderCardView_OnRender, aEnrolleeId);
}

function uSaveReportButton_OnClick(aEvent) {
    "use strict";
    //Hide the Save until after a Report has been chosen.
    $('.PopupWindow .SaveButton').hide();

    if (mReportsControls.ReportInstance.ReportValidator.IsValid()) {
        //Fill the objects with the entered values
        var inputElement;
        $('#' + mReportsData.Container).each(function (aIndex, aElement) {
            $(aElement).find('input, select').each(function (aSubIndex, aSubElement) {
                inputElement = findById(mReportsControls.ReportInstance.Filter, aSubElement.id);

                //If not dropdown, push data directly to element.Value.
                if (inputElement.FilterType != 3 && inputElement.FilterType != 4) {//If not single dropdown, If not multiple dropdown

                    inputElement.Value = $('#' + aSubElement.id).val();
                    inputElement.Text = $('#' + aSubElement.id).val();
                } else {

                    if (inputElement.FilterType === 3) {//If single dropdown
                        inputElement.Value = $('#' + aSubElement.id).val();
                        if (isNullOrUndefined(inputElement.Value)) {
                            inputElement.Value = $('#' + aSubElement.id + " option:first").val();
                        }
                        //push text from option to element.Text.
                        inputElement.Text = $('#' + aSubElement.id + ' option:selected').text();
                        if (inputElement.Text.length===0) {
                            inputElement.Text = $('#' + aSubElement.id + " option:first").text();
                        }
                    }
                    else {//If multiple dropdown
                        //put data in comma delimited string and push to element.Value.
                        //put text in comma delimited string and push to element.Text.

                        var realvalues = [];
                        var textvalues = [];
                        $('#' + aSubElement.id + ' option:selected').each(function (i, selected) {
                            realvalues[i] = $(selected).val();
                            textvalues[i] = $(selected).text();
                        });
                        inputElement.Value = realvalues.join(",");
                        inputElement.Text = textvalues.join(",");
                    }
                }
            });
        });

        mReportsControls.ReportInstance.SendEmail = $('#' + mReportsData.ReportContainer + ' #chkSendEmail').is(':checked');
        mActivityNotification.addNotification(localizeWrapper('cReportSaving') + mReportsControls.ReportInstance.ReportName);

        //Clone Report to remove Filters and save separately
        var lReportInstance = $.extend(true, {}, mReportsControls.ReportInstance),
            lAgents = getDataItems('Agents'),
            lStopAgents = getDataItems('AgentsStop');
        delete lReportInstance.Filter;
        delete lReportInstance.ReportValidator; //Remove Validator before sending to server
        var lOrganizationId;

        if (isNullOrUndefined(lAgents[lReportInstance.AgentId])) {
            lOrganizationId = lStopAgents[lReportInstance.AgentId].OrganizationId
        }
        else {
            lOrganizationId =  lAgents[lReportInstance.AgentId].OrganizationId;
        }
        lReportInstance.OrganizationId = lOrganizationId;
        lReportInstance.ReportStatus = 3; //Processing
        lReportInstance.Id = -1;
        lReportInstance.ReportGeneratedDate = new Date();
        lReportInstance.UpdatedUTC = new Date();

        var lTransactionId = moment().format("YYYYMMDDHHmmss");
        lReportInstance.TransactionId = lTransactionId;

        //I do not see a way to save the Parent/Child relationship together using the SUMO libraries.
        //If there is a way, either change the save or let me know how it works.
        // ClosePopup();
        $('#gifContainer').show();
        WriteSingle(lReportInstance, WriteReport_OnSuccess, WriteReport_OnFailure, lTransactionId, true);
        mReportsControls.ReportInstance.ReportValidator = new Validator(mReportsData.Container, mRegexValidation); //Add validator back in case form needs to submit again.
    } else {
        mActivityNotification.addNotification(localizeWrapper('cReportRequiredFiledNotice'));
    }
}

function GetReportByID_OnSuccess(aParams, aData) {
    "use strict";

    BuildReport(aData);
}

function GetReportByID_OnFailure(aParams, a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cReportGetDetailsFailed'));
}


function WriteReport_OnSuccess(aParams, aData) {
    "use strict";
    var i;
    if (aData.Id === -1) {
        // stored procedure failed
        WriteReport_OnFailure(aParams, {}, '', '');
    } else {
        // success

        // Save Report Filters
        //Loop across Filters adding to Data Object to submit
        var lReportFilterInstanceList = [];
        for (i in mReportsControls.ReportInstance.Filter) {
            if (!isNaN(parseFloat(i)) && isFinite(i)) {
                lReportFilterInstanceList[i] = getReportInstanceForSave(aData.Id, mReportsControls.ReportInstance.ReportId, mReportsControls.ReportInstance.Filter[i], aParams);
            }
        }

        var longRunningViewState = getViewState("LongRunningReport");

        if (!isNullOrUndefined(longRunningViewState) && !isNullOrUndefined(longRunningViewState.Value)) {
            longRunningViewState.Value.push(aData.Id);
        } else {
            var reportIds = [];
            reportIds.push(aData.Id);
            setViewState("LongRunningReport", reportIds);
        }



        WriteMultiple(lReportFilterInstanceList, WriteReportFilter_OnSuccess, WriteReportFilter_OnFailure, aData, true);
        mActivityNotification.addNotification(localizeWrapper('cReportSaving') + aData.Id);


        //Add Data to ReportInstance before injecting back into Data Card


        //aData.OrganizationId = lAgents[aData.AgentId].OrganizationId;

        //FixDates(aData);
        //setDataItem(aData.Id, 'ReportInstance', aData);
        //reportsDataItem_Updated();
        //mCache.UpdateItem('ReportInstance');
        //mReportsControls.CardView.selected(aData.Id);
        //resetReportsCardView();

        //mReportsControls.ReportInstance = new ReportInstance();
        //ClosePopup();
    }
}

function getReportInstanceForSave(aReportInstanceId, aReportId, aFilter, aTransactionId) {
    var lReportFilterInstance = new ReportFilterInstance();
    lReportFilterInstance.Id = aFilter.Id;
    lReportFilterInstance.ReportFilterId = aFilter.ReportFilterId;
    lReportFilterInstance.ReportId = aReportId;
    lReportFilterInstance.ReportInstanceId = aReportInstanceId;
    lReportFilterInstance.Text = aFilter.Text;
    lReportFilterInstance.TransactionId = aTransactionId;
    if (aFilter.Value instanceof Object == false) {
        lReportFilterInstance.Value = aFilter.Value;
    }
    else {
        lReportFilterInstance.Value = aFilter.Value[0];
    }

    return lReportFilterInstance;
}

function WriteReportFilter_OnSuccess(aParams, aData) {
    "use strict";

    var lItem,
        lKey;
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'ReportFilterInstance', lItem);
        }
    }

    var lReportInstance = aParams;
    lReportInstance.ReportStatus = 3; //Processing
    WriteSingle(lReportInstance, CreateReportProcessed_OnSuccess, CreateReportProcessed_OnFailure, aParams, true);
}

function CreateReportProcessed_OnSuccess(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportProcessSaveSuccess'));
    FixDates(aData);
    setDataItem(aData.Id, 'ReportInstance', aData);
    mReportsData.SkipUpdateBar = true; // set to do automatic update.
    mCache.UpdateItem('ReportInstance');
    mReportsControls.CardView.selected(aData.Id);
    resetReportsCardView();
    $('#gifContainer').hide();
    mReportsControls.ReportInstance = new ReportInstance();
    ClosePopup();

    //setTimeout(function () {
    //    RetrieveReport(aData);
    //}, 7000);
}

function RetrieveReport(aData) {
    var lBuilder = new SumoPredicateBuilder();
    lBuilder.AddNewExpressionConditional('ReportId', aData.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.ReportInstance.AssemblyQualifiedName, lBuilder.RootExpression, 0, CacheProcessedReport,null, aData, null, null, 0);

}

function CacheProcessedReport(aParams,aData) {
    setDataItem(aData.Id, 'ReportInstance', aData);
    //reportsDataItem_Updated();
    mCache.UpdateItem('ReportInstance');
}

function CreateReportProcessed_OnFailure(aParams, aData) {
    "use strict";
    var inhere = aData;
    ClosePopup();
    mActivityNotification.addNotification(localizeWrapper('cReportProcessSaveFailed'));
}
function WriteReportFilter_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportReportsFilterFailed'));
}

function WriteReport_OnFailure(aParams, a, b, c) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}

// REPORT FILTER OBJECTS
function TextBoxElement(aFilter) {
    "use strict";

    this.Id = -1;
    if (!isNullOrUndefined(aFilter.Id)) {
        this.Id = aFilter.Id;
    }
    this.ReportFilterId = -1;
    if (!isNullOrUndefined(aFilter.ReportFilterId)) {
        this.ReportFilterId = aFilter.ReportFilterId;
    }
    this.FilterName = '';
    if (!isNullOrUndefined(aFilter.FilterName)) {
        this.FilterName = aFilter.FilterName;
    }
    this.LabelName = '';
    if (!isNullOrUndefined(aFilter.LabelName)) {
        this.LabelName = aFilter.LabelName;
    }
    this.IsRequired = false;
    if (!isNullOrUndefined(aFilter.IsRequired)) {
        this.IsRequired = aFilter.IsRequired;
    }
    this.Value = null;
    this.FilterType = aFilter.FilterType;
    this.Render = function (aContainerId) {
        CreateTextBox(this, aContainerId);
    };
}

function DropDownElement(aFilter) {
    "use strict";

    this.Id = -1;
    if (!isNullOrUndefined(aFilter.Id)) {
        this.Id = aFilter.Id;
    }
    this.ReportFilterId = -1;
    if (!isNullOrUndefined(aFilter.ReportFilterId)) {
        this.ReportFilterId = aFilter.ReportFilterId;
    }
    this.FilterName = '';
    if (!isNullOrUndefined(aFilter.FilterName)) {
        this.FilterName = aFilter.FilterName;
    }
    this.LabelName = '';
    if (!isNullOrUndefined(aFilter.LabelName)) {
        this.LabelName =  localizeDataItem('',aFilter.LabelName) 
    }
    this.IsRequired = false;
    if (!isNullOrUndefined(aFilter.IsRequired)) {
        this.IsRequired = aFilter.IsRequired;
    }
    this.Options = [];
    if (!isNullOrUndefined(aFilter.Options)) {
        this.Options = FillOptions(this, aFilter.Options);
    }
    if (aFilter.FilterType === 4) {//FilterTypeEnum.MULTISELECT
        this.Value = [];
    } else {
        this.Value = '';
    }
    this.FilterType = aFilter.FilterType;
    this.Render = function (aContainerId) {
        CreateDropDown(this, aContainerId);
        if (this.Options.length >3 && this.FilterType == 3) {
            var lSelectField = $('#'+this.Id);
            lSelectField.style = "float:right;";
            lSelectField.select2({
                dropdownParent: $('#'+aContainerId),
            })
        }
    };
}

function Options(aId, aValue) {
    "use strict";

    this.Id = aId;
    this.Value = aValue;
}


//UI CONSTRUCTOR OBJECTS
function FillOptions(aElement, aOptions) {
    "use strict";
    var i;
    for (i in aOptions) {
        aElement.Options[i] = new Options(aOptions[i].Id, aOptions[i].Value);
    }
    return aElement.Options;
}

function CreateTextBox(aElement, aContainerId) {
    "use strict";

    CreateLabel(aElement.ReportFilterId, aElement.LabelName, aContainerId);

    var lClassNames = 'ReportFilter';
    if (aElement.IsRequired) {
        lClassNames = lClassNames + ' Validate ValidateRequired';
    }

    var lValue = '';
    if (aElement.FilterType === 1) {//FilterTypeEnum.DATETEXTBOX
        lValue = displayShortDate(new Date());
    }

    var Textinput = $('<input/>', {
        id: aElement.ReportFilterId,
        name: aElement.FilterName,
        type: 'text',
        value: lValue,
        'class': lClassNames,
    }).appendTo('#' + aContainerId);


    //If a date, add the date control.
    if (aElement.FilterType === 1) {//FilterTypeEnum.DATETEXTBOX
        populateDateView('#' + aElement.ReportFilterId, null);
    }
}

function CreateDropDown(aElement, aContainerId) {
    "use strict";
    CreateLabel(aElement.ReportFilterId, aElement.LabelName, aContainerId);

    var lClassNames = 'ReportFilter';
    if (aElement.IsRequired) {
        lClassNames = lClassNames + '  Validate ValidateRequired';
    }

    var lMultiple = null;
    if (aElement.FilterType === 4) {//FilterTypeEnum.MULTISELECT
        lMultiple = 'multiple';
    }

    var Listinput = $('<select/>', {
        id: aElement.ReportFilterId,
        name: aElement.FilterName,
        'class': lClassNames,
        type: 'select',
        multiple: lMultiple
    }).appendTo('#' + aContainerId);


    if (!isNullOrUndefined(aElement.Options) && aElement.Options.length > 0) {
        if (Listinput.prop) {
            var options = Listinput.prop('options');
        } else {
            var options = Listinput.attr('options');
        }

        $.each(aElement.Options, function (id, data) {
            if (!isNullOrUndefined(data)) {
                options[options.length] = new Option(data.Value, data.Id);
            }
        });

        if (aElement.IsRequired) {
            options[0].selected = true; //set to first option since there doesn't appear to be a select validator
        }
    }
}

function CreateCheckBox(aId, aLabelName, aContainerId) {
    "use strict";

    CreateLabel(aId, aLabelName, aContainerId);

    var lClassNames = 'ReportFilter Validate';

    var Textinput = $('<input/>', {
        id: 'chk' + aId,
        name: 'chk' + aId,
        type: 'checkbox',
        'class': lClassNames
    }).appendTo('#' + aContainerId);

}

function CreateLabel(aId, aName, aContainerId) {
    "use strict";

    $("<div/>", {
        id: 'lbl' + aId,
        'class': 'LabelText',
        text: aName
    }).appendTo('#' + aContainerId);
}


//UTILS
function findById(aSource, aId) {
    "use strict";

    var lObject,
        i;
    for (i = 0; i < aSource.length; i++) {
        lObject = aSource[i];
        if (lObject.ReportFilterId === parseInt(aId)) {
            return lObject;
        }
    }
    throw "Couldn't find object with id: " + aId;
}


function RenderAndPopulate(aReport, aContainer) {
    "use strict";

    var lObject,
        i;
    for (i in aReport.Filter) {
        if (!isNullOrUndefined(aReport.Filter[i].FilterType)) {
            switch (aReport.Filter[i].FilterType) {
                case 1: case 2: //FilterTypeEnum.DATETEXTBOX:FilterTypeEnum.TEXTBOX
                    lObject = new TextBoxElement(aReport.Filter[i]);
                    break;
                case 3: case 4: //FilterTypeEnum.SINGLESELECT:FilterTypeEnum.MULTISELECT
                    lObject = new DropDownElement(aReport.Filter[i]);
                    break;
                default:
                    mActivityNotification.addNotification(localizeWrapper('cReportFilterUnknownError'));
                    break;
            }
            lObject.Render(aContainer);
            mReportsControls.ReportInstance.Filter.push(lObject);
        } else {
            //Eat the move function added to the Array Prototype.
        }
    }
}

// LIST OF REPORTS
function ReportList() {
    "use strict";

    this.Options = [];

    //used for dropdown list
    this.Id = -1;
    this.IsRequired = true;
    this.LabelName = 'Choose Report';
    this.FilterName = 'ddlChooseReport';
    this.FilterType = 3; //FilterTypeEnum.SINGLESELECT
    this.Value = '';
}
//!*******************************************************************
//!********** FORMATTERS *********************************************

function reportStatusFormatter(aId) {
    "use strict";
    var lReturnValue;
    switch (aId) {
        case -1:
            lReturnValue = localizeText('cReportStatusNA');
            break;
        case 1:
            lReturnValue = localizeText('cReportStatusUnprocessed');
            break;
        case 2:
            lReturnValue = localizeText('cReportStatusQueued');
            break;
        case 3:
            lReturnValue = localizeText('cReportStatusProcessing');
            break;
        case 4:
            lReturnValue = localizeText('cReportStatusProcessed');
            break;
        default:
            lReturnValue = localizeText('cReportStatusError');
            break;
    }
    return lReturnValue;
}

function reportStatusNameFormatter(aName) {
    "use strict";
     return localizeText('cReportStatus' + aName);
}

//!*******************************************************************
//!**********  INSTANT REPORTS  **************************************

//Analysis Instant Report
function CreateAnalysisResultInstantReport(aIncidentId, aAgentId, aOrganizationId, lEnrolleesFilter, aRiskLevel) {
    "use strict";
    var lReportInstance = new ReportInstance(),
        lAgents = getDataItems('Agents'),
        lStopAgents,
        lOrganizationId,
        lItem;

    lReportInstance.Id = -1;
    lReportInstance.AgentId = aAgentId;
    lReportInstance.ReportName = 'Incident Report Instant';
    lReportInstance.ReportId = 252; //Analysis Result Report
    lReportInstance.SendEmail = 1;
    if (!isNullOrUndefined(lAgents[aAgentId])) {
        lOrganizationId = lAgents[aAgentId].OrganizationId;
    }
    else {
        lStopAgents = getDataItem(aAgentId, 'AgentsStop');
        lOrganizationId = lStopAgents.OrganizationId;
    }
    lReportInstance.OrganizationId = lOrganizationId;
    lReportInstance.ReportStatus = 3; //Processing

    mActivityNotification.addNotification(localizeWrapper('cReportIncidentInsReportSaving'));
    lItem = { 'incidentId': aIncidentId, 'organizationId': aOrganizationId, 'enrolleeFilter': lEnrolleesFilter, 'riskLevel': aRiskLevel, 'agentOrganizationId': lOrganizationId };
    WriteSingle(lReportInstance, CreateAnalysisResultInstantReport_OnSuccess, CreateEnrolleeProfileInstantReport_OnFailure, lItem, true);
}

function CreateAnalysisResultInstantReport_OnSuccess(aParams, aData) {
    "use strict";
    var lOrganizations = getDataItems('Organizations'),
        lIncidents = getDataItems('Incidents'),
        lEnrollees = getDataItems('Enrollees'),
        lRiskLevels = getDataItems('RiskLevels'),
        lIncident,
        lOrganization,
        lRiskLevel,
        lReportInstanFilers = [],
        lReportInstantFilterIncident = new ReportFilterInstance(),
        lReportInstantFilterEnrollee = new ReportFilterInstance(),
        lReportInstantFilterOri = new ReportFilterInstance(),
        lReportInstantFilterRiskLevel = new ReportFilterInstance();


    //Fitler for incident id
    lReportInstantFilterIncident.Id = -1;
    lReportInstantFilterIncident.ReportId = 252;//Analysis Result Report
    lReportInstantFilterIncident.ReportFilterId = 25210;//Analysis Result Report Filter Incident
    lReportInstantFilterIncident.ReportInstanceId = aData.Id;
    lIncident = lIncidents[aParams.incidentId];
    lReportInstantFilterIncident.Value = lIncident.Id;
    lReportInstantFilterIncident.Text = lIncident.IncidentNumber;
    lReportInstanFilers.push(lReportInstantFilterIncident);
    //Filter for enrollee id
    lReportInstantFilterEnrollee.Id = -1;
    lReportInstantFilterEnrollee.ReportId = 252;
    lReportInstantFilterEnrollee.ReportFilterId = 25220;//Analysis Result Report Filter Enrollee
    lReportInstantFilterEnrollee.ReportInstanceId = aData.Id;
    if (aParams.enrolleeFilter == 0) {
        lReportInstantFilterEnrollee.Value = '';
        lReportInstantFilterEnrollee.Text = 'All';
    } else {
        lReportInstantFilterEnrollee.Value = aParams.enrolleeFilter;
        lReportInstantFilterEnrollee.Text = aParams.enrolleeFilter;
    }
    lReportInstanFilers.push(lReportInstantFilterEnrollee);
    //Filter for ori id
    lReportInstantFilterOri.Id = -1;
    lReportInstantFilterOri.ReportId = 252;
    lReportInstantFilterOri.ReportFilterId = 25230//Analysis Result Report Filter Organization
    lReportInstantFilterOri.ReportInstanceId = aData.Id;
    if (aParams.organizationId == 0) {
        lReportInstantFilterOri.Value = 0;
        lReportInstantFilterOri.Text = 'All';
    } else {
        lOrganization = lOrganizations[aParams.organizationId];
        lReportInstantFilterOri.Value = lOrganization.Id;
        lReportInstantFilterOri.Text = lOrganization.Name;
    }
    lReportInstanFilers.push(lReportInstantFilterOri);
    //Filter for riskLevel id
    lReportInstantFilterRiskLevel.Id - 1;
    lReportInstantFilterRiskLevel.ReportId = 252;
    lReportInstantFilterRiskLevel.ReportFilterId = 25240//Analysis Result Report Filter risk level
    lReportInstantFilterRiskLevel.ReportInstanceId = aData.Id;
    if (aParams.enrolleeFilter.id == 0) {
        lReportInstantFilterRiskLevel.Value = 0;
        lReportInstantFilterRiskLevel.Text = '';
    } else {
        if (aParams.riskLevel == 0) {
            lReportInstantFilterRiskLevel.Value = 0
            lReportInstantFilterRiskLevel.Text = 'All';
        } else {
            lRiskLevel = lRiskLevels[aParams.riskLevel + "." + aParams.agentOrganizationId + "."];
            lReportInstantFilterRiskLevel.Value = lRiskLevel.Id;
            lReportInstantFilterRiskLevel.Text = lRiskLevel.Name;
        }

    }
    lReportInstanFilers.push(lReportInstantFilterRiskLevel);

    WriteMultiple(lReportInstanFilers, CreateAnalysisResultInstantReportFilter_OnSuccess, CreateEnrolleeProfileInstantReportFilter_OnFailure, aData, true);

}

function CreateAnalysisResultInstantReportFilter_OnSuccess(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportIncidentInsReportSaveSuccess'));
    var lReportInstance = aParams;
    lReportInstance.ReportStatus = 3; //Processing
    WriteSingle(lReportInstance, CreateInstantReportProcessed_OnSuccess, CreateInstantReportProcessed_OnFailure, aParams, true);
}

//Enrollee Profile Report
function CreateEnrolleeProfileInstantReport(aEnrolleeId, aAgentId) {
    "use strict";
    //Build Report Instance
    var lReportInstance = new ReportInstance(),
        lAgents = getDataItems('Agents'),
        lStopAgents,
        lOrganizationId;

    lReportInstance.Id = -1;
    lReportInstance.AgentId = aAgentId;
    lReportInstance.ReportName = 'Enrollee Profile Report';
    lReportInstance.ReportId = 39; //Enrollee Profile Report
    lReportInstance.SendEmail = 0;
    if (!isNullOrUndefined(lAgents[aAgentId])) {
        lOrganizationId = lAgents[aAgentId].OrganizationId;
    }
    else {
        lStopAgents = getDataItem(aAgentId, 'AgentsStop');
        lOrganizationId = lStopAgents.OrganizationId;
    }
    lReportInstance.OrganizationId = lOrganizationId;
    lReportInstance.ReportStatus = 3; //Processing

    mActivityNotification.addNotification(localizeWrapper('cReportEnrolleeProfileInsSaving'));
    WriteSingle(lReportInstance, CreateEnrolleeProfileInstantReport_OnSuccess, CreateEnrolleeProfileInstantReport_OnFailure, aEnrolleeId, true);
}

function CreateEnrolleeScheduleInstantReport(aEnrolleeId, aAgentId) {
  "use strict";
  //Build Report Instance
  var lReportInstance = new ReportInstance(),
      lAgents = getDataItems('Agents'),
      lStopAgents,
      lOrganizationId;

  lReportInstance.Id = -1;
  lReportInstance.AgentId = aAgentId;
  lReportInstance.ReportName = 'Enrollee Schedule Report';
  lReportInstance.ReportId = 76; //Enrollee Profile Report
  lReportInstance.SendEmail = 0;
  if (!isNullOrUndefined(lAgents[aAgentId])) {
      lOrganizationId = lAgents[aAgentId].OrganizationId;
  }
  else {
      lStopAgents = getDataItem(aAgentId, 'AgentsStop');
      lOrganizationId = lStopAgents.OrganizationId;
  }
  lReportInstance.OrganizationId = lOrganizationId;
  lReportInstance.ReportStatus = 3; //Processing

  mActivityNotification.addNotification(localizeWrapper('cReportEnrolleeScheduleInsSaving'));
  WriteSingle(lReportInstance, CreateEnrolleeScheduleInstantReport_OnSuccess, CreateEnrolleeProfileInstantReportFilter_OnFailure, aEnrolleeId, true);
}

function CreateEnrolleeScheduleInstantReport_OnSuccess(aParams, aData) {
    "use strict";

    //Build Filter
    var lEnrollee = GetEnrollee(aParams),
        lReportFilterInstance = new ReportFilterInstance();

    lReportFilterInstance.Id = -1;
    lReportFilterInstance.ReportId = 76; //Enrollee Schedule Report
    lReportFilterInstance.ReportFilterId = 7601; //Enrollee Schedule Report Filter for Enrollee Id
    lReportFilterInstance.ReportInstanceId = aData.Id; //get from Report Instance Save
    lReportFilterInstance.Value = aParams;
    lReportFilterInstance.Text = lEnrollee.FullName;

    WriteSingle(lReportFilterInstance, CreateEnrolleeProfileInstantReportFilter_OnSuccess, CreateEnrolleeProfileInstantReportFilter_OnFailure, aData, true);
}

function CreateEnrolleeProfileInstantReport_OnSuccess(aParams, aData) {
    "use strict";

    //Build Filter
    var lEnrollees = getDataItems('Enrollees'),
        lReportFilterInstance = new ReportFilterInstance();

    lReportFilterInstance.Id = -1;
    lReportFilterInstance.ReportId = 39; //Enrollee Profile Report
    lReportFilterInstance.ReportFilterId = 3901; //Enrollee Profile Report Filter for Enrollee Id
    lReportFilterInstance.ReportInstanceId = aData.Id; //get from Report Instance Save
    lReportFilterInstance.Value = aParams;
    lReportFilterInstance.Text = lEnrollees[aParams].FullName;

    WriteSingle(lReportFilterInstance, CreateEnrolleeProfileInstantReportFilter_OnSuccess, CreateEnrolleeProfileInstantReportFilter_OnFailure, aData, true);
}

function CreateEnrolleeScheduleInstantReportFilter_OnSuccess(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportEnrolleeScheduleInsSuccess'));
    var lReportInstance = aParams;
    lReportInstance.ReportStatus = 3; //Processing
    WriteSingle(lReportInstance, CreateInstantReportProcessed_OnSuccess, CreateInstantReportProcessed_OnFailure, aParams, true);
}

function CreateEnrolleeProfileInstantReportFilter_OnSuccess(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportEnrolleeProfileInsSuccess'));
    var lReportInstance = aParams;
    lReportInstance.ReportStatus = 3; //Processing
    WriteSingle(lReportInstance, CreateInstantReportProcessed_OnSuccess, CreateInstantReportProcessed_OnFailure, aParams, true);
}

function CreateEnrolleeProfileInstantReport_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}

function CreateEnrolleeProfileInstantReportFilter_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}

//Monitored Event Instant Report
function CreateMonitoredInstantReport(aMonitoredEventId, aAgentId) {
    "use strict";
    //Build Report Instance
    var lReportInstance = new ReportInstance(),
        lAgents = getDataItems('Agents'),
        lStopAgents,
        lOrganizationId;
    lReportInstance.Id = -1;
    lReportInstance.AgentId = aAgentId;
    lReportInstance.ReportName = 'Monitored Event Report Inst';
    lReportInstance.ReportId = 288;
    lReportInstance.SendEmail = 0;

    if (!isNullOrUndefined(lAgents[aAgentId])) {
        lOrganizationId = lAgents[aAgentId].OrganizationId;
    }
    else {
        lStopAgents = getDataItem(aAgentId, 'AgentsStop');
        lOrganizationId = lStopAgents.OrganizationId;
    }
    lReportInstance.OrganizationId = lOrganizationId;
    lReportInstance.ReportStatus = 3; //Processing

    mActivityNotification.addNotification(localizeWrapper('cReportMonitoredInsReportSaving'));
    WriteSingle(lReportInstance, CreateMonitoredEventInstantReport_OnSuccess, CreateMonitoredEventInstantReport_OnFailure, aMonitoredEventId, true);
}

function CreateMonitoredEventInstantReport_OnSuccess(aParams, aData) {
    "use strict";

    //Build Filter
    var lEnrollees = getDataItems('Enrollees'),
        lReportFilterInstance = new ReportFilterInstance();

    lReportFilterInstance.Id = -1;
    lReportFilterInstance.ReportId = 288; //Monitored Event Report
    lReportFilterInstance.ReportFilterId = 28810; //Monitored Event Report Filter for Enrollee Id
    lReportFilterInstance.ReportInstanceId = aData.Id; //get from Report Instance Save
    lReportFilterInstance.Value = aParams;
    lReportFilterInstance.Text = 'Monitored Event Id';
    setDataItem(aData.Id, 'ReportInstance', aData);
    WriteSingle(lReportFilterInstance, CreateMonitoredEventReportFilter_OnSuccess, CreateMonitoredEventInstantReportFilter_OnFailure, aData, true);
}

function CreateMonitoredEventReportFilter_OnSuccess(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportMonitoredInsReportSaveSuccess'));
    var lReportInstance = aParams;
    lReportInstance.ReportStatus = 3; //Processing
    setDataItem(aData.Id, 'ReportFilterInstance', aData);
    WriteSingle(lReportInstance, CreateInstantReportProcessed_OnSuccess, CreateInstantReportProcessed_OnFailure, aParams, true);
}

function CreateMonitoredEventInstantReport_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}

function CreateMonitoredEventInstantReportFilter_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}



//Enrollee Event Report
function CreateEnrolleeEventInstantReport(aParams, aAgentId) {
    "use strict";
    //Build Report Instance
    var lReportInstance = new ReportInstance(),
        lAgents = getDataItems('Agents'),
        lStopAgents,
        lOrganizationId;
    lReportInstance.Id = -1;
    lReportInstance.AgentId = aAgentId;
    lReportInstance.ReportName = 'Enrollee Event Report';
    lReportInstance.ReportId = 215; //Enrollee Event Report
    lReportInstance.SendEmail = 0;
    if (!isNullOrUndefined(lAgents[aAgentId])) {
        lOrganizationId = lAgents[aAgentId].OrganizationId;
    }
    else {
        lStopAgents = getDataItem(aAgentId, 'AgentsStop');
        lOrganizationId = lStopAgents.OrganizationId;
    }
    lReportInstance.OrganizationId = lOrganizationId;
    lReportInstance.ReportStatus = 3; //Processing

    mActivityNotification.addNotification(localizeWrapper('cReportEnrolleeEventInsReportSaving'));
    WriteSingle(lReportInstance, CreateEnrolleeEventInstantReport_OnSuccess, CreateEnrolleeEventInstantReport_OnFailure, aParams, true);
}

function CreateEnrolleeEventInstantReport_OnSuccess(aParams, aData) {
    "use strict";

    //Build Filters
    var lReportData = aParams,
        lReportFilterInstanceList = [];

    lReportFilterInstanceList[0] = getEnrolleeEventInstantReportFilter(aData.Id, 21510, lReportData.EnrolleeId, lReportData.EnrolleeName); //Enrollee Id
    lReportFilterInstanceList[1] = getEnrolleeEventInstantReportFilter(aData.Id, 21520, lReportData.StartDate, lReportData.StartDate); //Start Date
    lReportFilterInstanceList[2] = getEnrolleeEventInstantReportFilter(aData.Id, 21530, lReportData.EndDate, lReportData.EndDate); //End Date
    lReportFilterInstanceList[3] = getEnrolleeEventInstantReportFilter(aData.Id, 21540, lReportData.getEventsList(lReportData.EventsList), lReportData.getEventsListNames(lReportData.EventsListNames)); //Events
    //lReportFilterInstanceList[4] = getEnrolleeEventInstantReportFilter(aData.Id, 17050, lReportData.Duration, lReportData.DurationText); //Duration not needed
    lReportFilterInstanceList[4] = getEnrolleeEventInstantReportFilter(aData.Id, 21560, lReportData.getValue(lReportData.IsOpen), lReportData.getValue(lReportData.IsOpen)); //Is Open
    lReportFilterInstanceList[5] = getEnrolleeEventInstantReportFilter(aData.Id, 21570, lReportData.getValue(lReportData.IsConfirmed), lReportData.getConfirmedText(lReportData.IsConfirmed)); //Is Confirmed

    //WriteMultiple(lReportFilterInstanceList, CreateEnrolleeEventInstantReportFilter_OnSuccess, CreateEnrolleeEventInstantReportFilter_OnFailure, null, true);
    WriteMultiple(lReportFilterInstanceList, CreateEnrolleeEventInstantReportFilter_OnSuccess, CreateEnrolleeEventInstantReportFilter_OnFailure, aData, true);
}

function EnrolleeEventInstantReportData() {
    "use strict";

    this.EnrolleeId = -1;
    this.EnrolleeName = '';
    this.StartDate = '';
    this.EndDate = '';
    this.EventsList = '';
    this.EventsListNames = '';
    this.Duration = 0;
    this.DurationText = '--All--';
    this.IsOpen = -1;
    this.IsConfirmed = -1;
}

EnrolleeEventInstantReportData.prototype.getConfirmedText = function (aValue) {
    var lReturnValue;
    switch (aValue) {
        case -1:
            lReturnValue = "Both";
            break;
        case 0:
            lReturnValue = "No";
            break;
        case 1:
            lReturnValue = "Yes";
            break;
        default:
            lReturnValue = "error";
            break;
    }
    return lReturnValue;
};

EnrolleeEventInstantReportData.prototype.getValue = function (aValue) {
    var lReturnValue;
    switch (aValue) {
        case -1:
            lReturnValue = "Both";
            break;
        case 0:
            lReturnValue = "No";
            break;
        case 1:
            lReturnValue = "Yes";
            break;
        default:
            lReturnValue = "error";
            break;
    }
    return lReturnValue;
};

EnrolleeEventInstantReportData.prototype.getEventsList = function (aValue) {
    var lReturnValue;
    if (aValue === '') {
        lReturnValue = '0';
    } else {
        lReturnValue = aValue;
    }
    return lReturnValue;
};

EnrolleeEventInstantReportData.prototype.getEventsListNames = function (aValue) {
    var lReturnValue;
    if (aValue === '') {
        lReturnValue = '--All--';
    } else {
        lReturnValue = aValue;
    }
    return lReturnValue;
};


function getEnrolleeEventInstantReportFilter(aReportInstanceId, aReportFilterId, aValue, aText) {
    "use strict";
    var lReportFilterInstance = new ReportFilterInstance();

    lReportFilterInstance.Id = -1;
    lReportFilterInstance.ReportId = 215; //Enrollee Event Report
    lReportFilterInstance.ReportInstanceId = aReportInstanceId; //get from Report Instance Save
    lReportFilterInstance.ReportFilterId = aReportFilterId;
    lReportFilterInstance.Value = aValue;
    lReportFilterInstance.Text = aText;

    return lReportFilterInstance;
}


function CreateEnrolleeEventInstantReportFilter_OnSuccess(aParams, aData) {
    "use strict";
    mActivityNotification.addNotification(localizeWrapper('cReportEnrolleeEventInsReportSaveSuccess'));
    var lReportInstance = aParams;
    lReportInstance.ReportStatus = 3;
    WriteSingle(lReportInstance, CreateInstantReportProcessed_OnSuccess, CreateInstantReportProcessed_OnFailure, aParams, true);

}

function CreateEnrolleeEventInstantReport_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}

function CreateEnrolleeEventInstantReportFilter_OnFailure(aParams, aData) {
    "use strict";

    mActivityNotification.addNotification(localizeWrapper('cReportSaveFail'));
}
function CreateInstantReportProcessed_OnSuccess(aParams, aData) {
    mActivityNotification.addNotification(localizeWrapper('cReportUpdateSuccess'));
}

function CreateInstantReportProcessed_OnFailure(aParams, aData) {
    mActivityNotification.addNotification(localizeWrapper('cReportUpdateFailed'));
}

function uPreviewReportButton_OnClick() {
    "use strict";
    var reportPreviewURL = veritracks.system.clientSetting('veritracksreportpreview');
    var lUrl = "https://a1php21.lab.veritracks.com/CRweb/";

    if (reportPreviewURL) {
        lUrl = reportPreviewURL;
    }
    window.open(lUrl, '_blank');
}
//function uDeleteMeDeleteMe_OnClick() {

//    var lInstantReportData = new EnrolleeEventInstantReportData();
//    lInstantReportData.EnrolleeId = 4611;
//    lInstantReportData.EnrolleeName = 'Brock Samson';
//    //lInstantReportData.StartDate = '11/01/2012';
//    //lInstantReportData.EndDate = '12/17/2012';
//    //lInstantReportData.EventsList = '16,1003';
//    //lInstantReportData.EventsListNames = '+CHG: ON CHARGER, +MTPR: MASTER TAMPER';
//    //lInstantReportData.IsOpen = 0;
//    //lInstantReportData.IsConfirmed = 1;

//    CreateEnrolleeEventInstantReport(lInstantReportData, 1231);

//}

if (typeof exports !== 'undefined') {
    module.exports = {
        "DropDownElement": DropDownElement,
        "CreateLabel": CreateLabel,
        "CreateDropDown": CreateDropDown,
        "CreateCheckBox": CreateCheckBox,
        "FillOptions": FillOptions,
        "Options":Options
    };
}